import * as React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button } from 'react-bootstrap';
import { useState, useRef } from "react";
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { variables } from '../Variables';
import { setMailVerificationDetail, clearMailVerificationDetail } from "../features/EmailVerificationSlice";

import closeIcon from '../assets/images/cross-close.svg';
import placeholderLarge from '../assets/images/prop-placeholder-lg.jpg';
import locationPin from '../assets/images/location-pin-grey.svg';
import bedIcon from '../assets/images/bed.svg';
import showerIcon from '../assets/images/p_shower.svg';
import liftIcon from '../assets/images/lift.svg';
import userIcon from '../assets/images/user-alt.svg';
import envelopeIcon from '../assets/images/envelope.svg';
import phoneBlack from '../assets/images/phone_black.svg';
import mindfreeLogo from '../assets/images/Mindfree_Logo.svg';
import successTick from '../assets/images/success_tick.svg';
import fileIcon from '../assets/images/file-icon.svg';
import uploadIcon from '../assets/images/upload-icon.svg';
import dateIcon from '../assets/images/date-white-icon.svg';
import timeIcon from '../assets/images/time-white-icon.svg';
import waitingScreenSuccess from '../assets/images/waiting-screen-success.svg';
import errorMessage from '../assets/images/error-message.svg';
import { addNewWhiseEventOnWhise, agentEmailNotSentInfoToClient, checkEventStartEndTimeFromDBisAlreadyExist, contactQuesDoucUploadDetailObj, expectionLoging, freeSlotEventToConfirmEventHandling, getEstateAndOfficeSetting, getIpAddress, mergeAnswerInOrginalEstateConfigObj, questionOrderSort, sendErrorEmailToClient, whiseEventDeletFromWhise } from "../utils/commonService";
import { addNewWhiseEventByAccountType, getClientWhiseTokenByUserAccountType, getUserAccountType, getWhiseTokenByUserAccountType } from "../utils/whiseApiService";
import { sendCalendarCreateApiErrorEmail, sendCancelledVisitEmailToContact } from "../utils/emailTempletesService";
import { validateEmail } from "../utils/validationService";

export const EventModal = ({
    showModal, handleClose, clientToken, eventSlot, estate, getAction, callbackGetToBeConfirmedIds, calendarActions, parent, resetSelectedSlot, officeId, clientId,
    clientSettings, time, formStep, setFormStep, prevSelectedEventSlot, selectedLanguage, selectedLanguageTranslations, agentLanguageTranslation,
    officeLogoUrl, officeSetting, whiseOffice, queryParams, contactTitles, formattedDate, freeSlotNotAvailable, checkEstateStatusInDB, contactId, waitingListContactDetail,
    iframe, setAgentLanguageTranslation, translationsForAllLanguages, isAutomaticSlotAccept
}) => {
    const [estateconfigurations, setEstateConfigurations] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [mobile, setMobile] = useState("");
    const [isNameEmpty, setIsNameEmpty] = useState(false);
    const [isFirstNameEmpty, setIsFirstNameEmpty] = useState("");
    const [isEmailEmpty, setIsEmailEmpty] = useState("");
    const [isMobileEmpty, setIsMobileEmpty] = useState("");
    const [requiredFieldMessage, setRequiredFieldMessage] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [errors, setErrors] = useState({});
    const [documentUrls, setDocumentUrls] = useState([]);
    const [freeTextForQuestions, setFreeTextForQuestions] = useState(null);
    const [freeTextForDocTypes, setFreeTextForDocTypes] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [isTitleEmpty, setIsTitleEmpty] = useState(false);
    const [translatedTitles, setTranslatedTitles] = useState([]);
    const [emailSendStatus, setEmailSendStatus] = useState(false);
    const [contactTitleList, setContactTitleList] = useState([]);
    const [addNewContactInWaitingTableStatus, setAddNewContactInWaitingTableStatus] = useState(null);
    const [waitingListBtnDisabled, setWaitingListBtnDisabled] = useState(false);
    const [eventUser, setEventUser] = useState(null);
    const [showMessageIfAlreadyContactHavingEvents, setShowMessageIfAlreadyContactHavingEvents] = useState("");
    const [disabledNextBtnInFormFistStep, setDisabledNextBtnInFormFistStep] = useState(false);
    const [contactDetailForAgainEventCreate, setContactDetailForAgainEventCreate] = useState(null);
    const [agentLanguage, setAgentLanguage] = useState(null);
    const [tbcEventNotUpdate, setTbcEventNotUpdate] = useState(false);

    const [userAccountType, setUserAccountType] = useState("");
    const [clientWhiseTokenByUserAccountType, setClientWhiseTokenByUserAccountType] = useState("");

    //console.log(estate);
    const fileInputRefs = useRef({});
    const emailSentRef = useRef(false);

    let eventExist = false;

    const [answers, setAnswers] = useState({});
    const dispatch = useDispatch();

    const emailVerificationDetail = useSelector(state => state.emailVerification.mailVerificationDetail);

    useEffect(() => {
        if (queryParams && Object.keys(queryParams).length > 0 && name === "" && firstName === "" && email === "" && mobile === "") {
            // Convert queryParams keys to lowercase
            const normalizedParams = Object.keys(queryParams).reduce((acc, key) => {
                acc[key.toLowerCase()] = queryParams[key]; // Store value with lowercase key
                return acc;
            }, {});

            setName(normalizedParams["name"] || "");
            setFirstName(normalizedParams["firstname"] || "");
            setEmail(normalizedParams["email"] || "");
            setMobile(normalizedParams["mobile"] || "");
        }
    }, [queryParams]);

    const getAgents = async (clientToken) => {
        let url = "https://api.whise.eu/v1/admin/representatives/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                const agentList = response.data.representatives;
                const filterAgent = agentList.filter(item => item.id == eventSlot.users[0].userId);
                //console.log(filterAgent);
                setEventUser(filterAgent[0]);
                //setWhiseAgents(response.data.representatives);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const getConfigurations = () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const url = variables.API_URL + `calendar/GetEstateConfigurationsOnBookingSite?clientId=${clientId}&estateId=${estate.id}`;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                if (response.data && response.data.configurationDetail) {
                    const parsedConfigData = JSON.parse(response.data.configurationDetail);
                    //console.log(parsedConfigData);
                    let updateObjectQuestionOrder;

                    if (waitingListContactDetail != null && waitingListContactDetail.questionAnswerDetail != null && iframe == "waiting-list") {
                        // merge answer from waiting list detail in orginal estate config obj
                        let afterMergeAnsInOrgEstateConfigObj = mergeAnswerInOrginalEstateConfigObj(parsedConfigData, waitingListContactDetail.questionAnswerDetail);
                        updateObjectQuestionOrder = questionOrderSort(afterMergeAnsInOrgEstateConfigObj); // question order sort
                        // console.log(updateObjectQuestionOrder);
                    } else {
                        updateObjectQuestionOrder = questionOrderSort(parsedConfigData); // question order sort
                    }

                    setEstateConfigurations(updateObjectQuestionOrder);

                    if (parsedConfigData.freeTextForQuestions) {
                        setFreeTextForQuestions(JSON.parse(parsedConfigData.freeTextForQuestions));
                    }

                    if (parsedConfigData.freeTextForDocTypes) {
                        setFreeTextForDocTypes(JSON.parse(parsedConfigData.freeTextForDocTypes));
                    }

                    /*updateObjectQuestionOrder = {
                        ...parsedConfigData,
                        questions: parsedConfigData.questions.sort((a, b) => a.order - b.order)
                    }*/

                    //setEstateConfigurations(waitingListContactDetail != null && iframe == "waiting-list" ? waitingListContactDetail.questionAnswerDetail : updateObjectQuestionOrder); // parsedConfigData => replace for question order new object
                    // setFreeTextForQuestions(JSON.parse(waitingListContactDetail != null && iframe == "waiting-list" ? waitingListContactDetail.questionAnswerDetail != null ? waitingListContactDetail.questionAnswerDetail.freeTextForQuestions : null : parsedConfigData.freeTextForQuestions));
                    // setFreeTextForDocTypes(JSON.parse(waitingListContactDetail != null && iframe == "waiting-list" ? waitingListContactDetail.questionAnswerDetail != null ? waitingListContactDetail.questionAnswerDetail.freeTextForDocTypes : null : parsedConfigData.freeTextForDocTypes));


                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const getSpecificAgentDetailFromLocalDB = async (agentId) => {
        try {
            let url = `${variables.API_URL}Estate/GetAgentById?agentId=${agentId}`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);
            if (response.data) {
                //console.log(response.data.language);
                const agentLanguage = response.data.language || clientSettings?.defaultLanguageId || "fr-BE";
                setAgentLanguage(agentLanguage);
                const agentTranslation = translationsForAllLanguages[agentLanguage];
                setAgentLanguageTranslation(agentTranslation);

                // get user acccount type
                const specificUserAccountType = await getUserAccountType(clientId);
                setUserAccountType(specificUserAccountType);

                // check user account type
                if (specificUserAccountType == variables.UserAccountTypeIdentity) { // "SystemIntegrator"
                    const getWhiseToken = await getWhiseTokenByUserAccountType();
                    const getClientWhiseToken = await getClientWhiseTokenByUserAccountType(getWhiseToken, clientId, userAccountType, officeId);
                    setClientWhiseTokenByUserAccountType(getClientWhiseToken);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (eventSlot != null && clientToken != "") {
            getAgents(clientToken);
            //console.log(eventSlot.users[0].userId);
            getSpecificAgentDetailFromLocalDB(eventSlot.users[0].userId); // get specifice agent detail
        }
    }, [clientToken, eventSlot]);

    useEffect(() => {
        if (clientId != "" && estate != null) {
            getConfigurations();
        }
    }, [clientId, estate]);

    const checkContactHavingEventsIsAlreadyOrNot = async (email) => {

        try {
            const url = `${variables.API_URL}Calendar/IsAlreadyBookedOrVisiterContactApi`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                client_Id: clientId,
                contact_private_email: email,
                estate_Id: estate.id
            }

            /*const body = {
                client_Id: 11613,
                contact_private_email: "abdulsaboor5059@gmail.com",
                estate_Id: 7053052
            }*/

            const response = await axios.post(url, body, config);
            console.log(response.data);
            if (response.data) {
                setShowMessageIfAlreadyContactHavingEvents(response.data);
                //return response.data;
            }
        } catch (error) {
            console.error(error);
        }
    }

    // Validation and preview screen next button 
    const clickHandlerPreviewContactDetail = () => {
        setDisabledNextBtnInFormFistStep(true);
        let errorMessages = [];
        let isFieldEmpty = false;
        const docTypeErrors = {};

        if (translatedTitles.length > 0 && (selectedTitle == null || selectedTitle == 0)) {
            isFieldEmpty = true;
            setIsTitleEmpty(true);
            let _message = selectedLanguageTranslations ? selectedLanguageTranslations["selectContactTitleValdiationMessage"] : "please select contact title.";
            errorMessages.push({ field: "contactTitle", message: _message });

        }

        let mailValidation = validateEmail(email);
        //console.log(mailValidation);

        if (name == "") {
            isFieldEmpty = true;
            setIsNameEmpty(true);
            let _message = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteNameFieldErrorMessage"] : "please enter your name.";
            errorMessages.push({ field: "name", message: _message });
        }
        if (firstName == "") {
            isFieldEmpty = true;
            setIsFirstNameEmpty(true);
            let _message = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteFirstNameFieldErrorMessage"] : "please enter your first name.";
            errorMessages.push({ field: "firstName", message: _message });
        }
        if (email == "" || mailValidation == false) {
            isFieldEmpty = true;
            setIsEmailEmpty(true);
            let _message = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteEmailFieldErrorMessage"] : "please enter a valid email address.";
            errorMessages.push({ field: "email", message: _message });
        }

        if (mobile == "" || mobile.length < 10 || mobile == null) {
            isFieldEmpty = true;
            setIsMobileEmpty(true);
            let _message = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteMobileFieldErrorMessage"] : "please enter a valid mobile number.";
            errorMessages.push({ field: "mobile", message: _message });
        }

        let _qMessage = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteQuestionsFieldErrorMessage"] : "please enter answer of question";
        if (estateconfigurations != null && estateconfigurations.questions != undefined && estateconfigurations.questions.length > 0) {
            estateconfigurations.questions.forEach((question, i) => {
                if (question.isMandatory === true && (question.answerText == undefined || question.answerText == "")) {
                    isFieldEmpty = true;
                    document.getElementById(`question${question.questionId}`).classList.add("border-red");
                    errorMessages.push({ field: `question${question.questionId}`, message: _qMessage + " " + (i = i + 1) });
                }
            });
        }

        let _docMessage = selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSiteDocumentsFieldErrorMessage"] : "Please select a file for";
        if (estateconfigurations != null && estateconfigurations.requiredDocuments != undefined && estateconfigurations.requiredDocuments.length > 0) {
            estateconfigurations.requiredDocuments.forEach(docType => {
                if (!selectedFiles[docType.id] && docType.isMandatory) {
                    isFieldEmpty = true;
                    errorMessages.push({ field: `docType${docType.id}`, message: _docMessage + " " + docType.label + "." });
                    docTypeErrors[docType.id] = true
                }
            });
        }

        if (isFieldEmpty == true) {
            //setRequiredFieldMessage(`${selectedLanguageTranslations != null ? selectedLanguageTranslations["alertContactModalFieldEmpty"] : "please fill the required fields"}`)
            setRequiredFieldMessage(errorMessages);
            setErrors(docTypeErrors);
            setDisabledNextBtnInFormFistStep(false);
            return true;
        }
        setRequiredFieldMessage([]);
        setErrors({});


        if (checkEstateStatusInDB == "Active") {
            checkContactHavingEventsIsAlreadyOrNot(email); // check contact having event already or not
            /*setFormStep(2)*/
            setTimeout(() => { setFormStep(2) }, 500);
            setDisabledNextBtnInFormFistStep(false);
        }

        /* const checkContactAlreadyHaveEvents = checkContactHavingEventsIsAlreadyOrNot(email); // check contact having event already or not
         setFormStep(2);*/
    }

    const sendEmailToContact = async () => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        //const clientLanguage = clientSettings.defaultLanguageId;
        const startEventDate = new Date(eventSlot.startDateTime);

        let html = "";
        html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px auto;'>";
        html += "<tr>";
        html += "   <td style='text-align: center; padding: 30px 0px 50px 0px;'>";
        if (officeLogoUrl) {
            html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
        } else if (clientSettings != null && clientSettings.logoUrl != undefined) {
            html += "   <img src='" + clientSettings.logoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
        } else {
            html += "   <img src='" + variables.AgentSiteURL + "assets/logo-placeholder.png' width='200' style='margin: 0 auto; display: block;' />";
        }
        html += "   </td>";
        html += "</tr>";
        html += "<tr>";
        html += "   <td style='text-align: center; padding: 0 20px 5px 20px;'>";
        html += `       <h5 style='font-size: 20px;font-weight: 700;color: #111827;font-family: Roboto; margin: 0px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailSuccessHeading"] : "Your visit request has been sent successfully to the agency."}</h5>`;
        html += "   </td>";
        html += "</tr>";
        html += "<tr>";
        html += "   <td style='text-align: center; padding: 0 20px 50px 20px;'>";
        html += `       <p style='font-size: 16px;font-weight: 400;color: #111827;font-family: Roboto; margin: 0px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailSuccessSubHeading"] : "They will review your request as soon as possible and you will be notified."}</p>`;
        html += "   </td>";
        html += "</tr>";
        html += "<tr>";
        html += "   <td style='text-align: start; padding: 0 20px 10px 20px;'>";
        html += `       <p style='font-size: 14px;font-weight: 600;color: #111827;font-family: Roboto; text-align: left; margin: 0;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailResumeHeading"] : "RESUME OF YOUR VISIT REQUEST"}</p>`;
        html += "   </td>";
        html += "</tr>";
        html += "<tr>";
        html += "   <td style='text-align: center; padding: 0px 20px 30px 20px;'>";
        html += "       <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px;'>";
        html += "        <tbody>";
        html += "           <tr>";
        html += "               <td style='padding: 20px;'>";
        html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailDateTitle"] : "Date"}</h5>`;
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 20px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px;'>" + formatDateTimeLanguageSpecific(selectedLanguage, eventSlot.startDateTime) + "</p>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 20px 20px;'>";
        html += "                   <hr>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 20px 20px;'>";
        html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailEstateHeading"] : "Property"}</h5>`;
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px;'>";
        html += "                   <div style='float: left;'>";
        if (estate.pictures != undefined && estate.pictures.length > 0 && estate.pictures[0].urlLarge != undefined) {
            html += "                   <img src='" + estate.pictures[0].urlLarge + "' className='rounded-4' width='170' alt='house image' />";
        }
        html += "                   </div>";
        html += "                   <div style='float: left; padding-left: 20px'>";
        if (estate.name != undefined) {
            html += "                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;'> " + estate.name + " </h5>";
        } else {
            html += " ";
        }
        html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0; vertical-align: text-top;'>";
        html += "                           <img src='" + variables.AgentSiteURL + "assets/location-pin.png' width='15' style='vertical-align: text-top;' />";
        html += "                           &nbsp;" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city);
        html += "                       </p>";

        //html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;vertical-align: text-top;'>";
        //html += "                           <img src='" + variables.AgentSiteURL + "assets/bed-duo.png' width='20' style='vertical-align: text-top;' />";
        //html += "                           &nbsp;" + (estate.bedRooms == undefined ? "" : estate.bedRooms);
        //html += "                           &nbsp; <span> | </span> &nbsp;";
        //html += "                           <img src='" + variables.AgentSiteURL + "assets/shower-duo.png' width='20' style='vertical-align: text-top;' />";
        //html += "                           &nbsp;" + (estate.bathRooms == undefined ? "" : estate.bathRooms);
        //html += "                           &nbsp; <span> | </span> &nbsp;";
        //html += "                           <img src='" + variables.AgentSiteURL + "assets/lift-duo.png' width='20' style='vertical-align: text-top;' />";
        //html += "                           &nbsp;" + (estate.area == undefined ? "" : estate.area);
        //html += "                       </p>";
        html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;vertical-align: middle;'>";
        html += "                           <img src='" + variables.AgentSiteURL + "assets/bed-duo.png' width='20' style='vertical-align: middle;' />";
        html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bedRooms == undefined ? "" : estate.bedRooms} </span>`;
        html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
        html += "                           <img src='" + variables.AgentSiteURL + "assets/shower-duo.png' width='20' style='vertical-align: middle;' />";
        html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bathRooms == undefined ? "" : estate.bathRooms}</span>`;
        html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
        html += "                           <img src='" + variables.AgentSiteURL + "assets/lift-duo.png' width='20' style='vertical-align: middle;' />";
        html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.area == undefined ? "" : estate.area}</span>`;
        html += "                       </p>";
        html += "                   </div>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 20px 20px;'>";
        html += "                   <hr>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 20px 20px;'>";
        html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailContactsHeading"] : "Contacts"}</h5>`;
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 5px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; margin: 0px; text-align: left;'>" + firstName + " " + name + "</p>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 5px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px;'>" + email + "</p>";
        html += "               </td>";
        html += "           </tr>";
        html += "           <tr>";
        html += "               <td style='padding: 0px 20px 20px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + mobile + "</p>";
        html += "               </td>";
        html += "           </tr>";
        //html += "           <tr>";
        //html += "               <td style='padding: 0px 20px 20px 20px;'>";
        //html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" +  + "</p>";
        //html += "               </td>";
        //html += "           </tr>";
        html += "        </tbody>";
        html += "       </table>";
        html += "   </td>";
        html += "</tr>";
        html += "</table>";

        let subject = (selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailSubjectBeforeEstateId"] : "Your request for the visit of the property") + " " + estate.id + " " + (selectedLanguageTranslations != null ? selectedLanguageTranslations["visitRequestEmailSubjectAfterEstateId"] : "has been sent to the agency");

        let sendTo = email;
        //let sendTo = "adnanmustafa.n122@gmail.com";
        let objEmail = {
            emailTo: sendTo,
            body: html,
            subject: subject,
            emailType: "contact"
        }

        const url = variables.API_URL + `Email/SendEmail?`;
        axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var resp = response.data;
                if (resp == "Email Sent successfully") {

                }

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const sendEmailToContactConfirmedSlot = async (newWhiseEventDetail, newWhiseCalenderEvent) => {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        let title = contactTitleList.filter(item => {
            return item.id == newWhiseCalenderEvent[0].contacts[0].contactTitle.id;
        })

        let visitingDate = new Date(newWhiseEventDetail.StartDateTime);
        let hours = visitingDate.getHours() < 10 ? "0" + visitingDate.getHours() : visitingDate.getHours();
        let minutes = visitingDate.getMinutes() < 10 ? "0" + visitingDate.getMinutes() : visitingDate.getMinutes();
        let time = hours + ":" + minutes;

        let html = "<div style='border: 1px solid gray; background-color: white; border-radius: 16px; padding: 20px; width: 80%; margin: 0 auto; text-align: left'>";
        html += "   <div>";
        if (officeLogoUrl) {
            html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
        }
        else if (clientSettings != null && clientSettings.logoUrl != undefined) {
            html += "   <img src='" + clientSettings.logoUrl + "' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
        } else {
            html += "   <img src='" + window.location.origin + "/assets/logo-placeholder.png' width='200' style='margin: 0 auto; margin-bottom: 1.5rem;' />";
        }
        html += "   </div > "; /*<strong>${eventSlot.users[0].name} </strong>*/
        html += `   <h5 style='font-size: 24px;font-weight: 500;color: #111827;font-family: Poppins; margin: 0; margin-bottom: 1.5rem'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailVisitRequestHasBeenAcceptedText"] : "Your Visit request has been accepted by"} <strong>${eventUser.name} </strong> ${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailOfTheAgencyText"] : "of the agency"} ${officeId}</h5>`;
        html += "   <div  style='margin-bottom: 1.5rem; border: 1px solid gray; border-radius: 8px; text-align: left; padding: 15px;'>";
        html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailVisitingPropertyLocatedText"] : "You're visiting the property located:"}</h5>`;
        html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem'>" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city) + "</p>";
        html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; margin-top: 1.5rem'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialEmailDateLabel"] : "Date"}</h5>`;
        html += "       <p style='font-family: Poppins; font-size: 14px; line-height: 20.8px; color: #111827; margin: 0;'>" + formatDateTimeLanguageSpecific(selectedLanguage, new Date(newWhiseEventDetail.StartDateTime)) + "</p>";
        html += "   </div>";
        html += "   <div style='margin-bottom: 1.5rem; background-color: #FBEFEF; border-radius: 8px; text-align: left; padding: 15px;'>";
        html += `       <h5 style='font-family: Poppins; font-size: 16px; line-height: 20.8px; color: #111827; margin: 0; margin-bottom: 1rem; color: #CF132A'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailRemarkLabel"] : "Remarque"}</h5>`;
        html += `       <p style='margin: 0; font-family: Poppins; font-size: 14px;'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailRemarkSectionText"] : "You will receive second email confirmation from the agency with the electronic invitation to add on your agenda. Later, if you're not able to attend to the visit appointment please come back on this email and click on the button below OR call the agency at +32 02 487 878"}</p>`;
        html += "   </div>";
        html += "   <div style='display: flex; align-items: center; justify-content: space-between; font-family: Poppins'>"
        html += `       <a href='#' style='margin-right: 10px; border: 1px solid #111827; text-decoration: none; width: 50%; margin:auto; padding: 9px 10px; border-radius: 8px; text-align: center; color: #111827; font-size: 14px'>${selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationEmailCancelVisitButtonText"] : "Cancel the Visit"}</a>`;
        //html += "       <a href='#' style='background-color: #274B97; color: white; text-decoration: none; width: 100%; padding: 10px; border-radius: 8px; text-align: center;font-size: 14px'>Reschedule the Visit</a>"
        html += "   </div>"
        html += "</div> ";

        let subject = `Confirmation ${title.length > 0 ? title[0].shortDescription : ""} ${firstName} you're visiting the property ${newWhiseEventDetail.EstateIds[0]} on ${visitingDate.toDateString()} ${time} `;

        let sendTo = email;
        //let sendTo = "abdulsaboor5059@gmail.com";

        let objEmail = {
            emailTo: sendTo,
            body: html,
            subject: subject,
            emailType: "contact"
        }
        //console.log(objEmail);
        const url = variables.API_URL + `Email/SendEmail?`;
        axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                var resp = response.data;
                console.log(resp);
                if (resp == "Email Sent successfully") {

                }

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const clickHandlerConfirmSlot = async (e) => {
        setWaitingListBtnDisabled(true);
        /* e.target.setAttribute("disabled", true);
         e.target.style.cursor = "progress";
         document.querySelector("body").style.cursor = "progress";*/

        try {
            let uploadedFiles = await handleSubmit();
            setDocumentUrls(uploadedFiles.urls);
            let body = {}
            body.CalendarIds = [+eventSlot.id]
            if (eventSlot.isLocalDbEvent) {
                await getLocalCalenderEventById(eventSlot.id)
            }
            else {
                await getWhiseCalenderEventById(body);
            }
            if (eventExist) {
                dispatch(clearMailVerificationDetail());
                let contactbody = {
                    Name: name,
                    PrivateEmail: email,
                    OfficeIds: [+estate.officeId], //[+officeId],
                    PrivateMobile: mobile,
                    FirstName: firstName,
                    CountryId: 1,
                    StatusId: 1, // 
                    EstateIds: [estate.id],
                    Message: "Contact created via Smartcalendar app",
                    AgreementEmail: true,
                    AgreementSms: true,
                    AgreementMailingCampaign: true,
                    AgreementSmsCampaign: true,
                    //FunnelStatusId: 3,
                    LanguageId: selectedLanguage //'fr-BE'
                };

                if (translatedTitles.length > 0 && selectedTitle) {
                    contactbody.ContactTitleId = selectedTitle.value;
                }

                //addContactOnWhise(contactbody, e, uploadedFiles);
                addContactOnWhise(contactbody, uploadedFiles);
                //setFormStep(3);
            }
            else {
                alert(`${selectedLanguageTranslations != null ? selectedLanguageTranslations["alertSlotAlreadyBooked"] : "This Slot is already booked and not available please try an Other slot"}`);
                e.target.removeAttribute("disabled");
                e.target.style.cursor = "";;
                document.querySelector("body").style.cursor = "";
                setWaitingListBtnDisabled(false);
            }
        }
        catch (error) {
            alert(`error: ${error}`);
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";;
            document.querySelector("body").style.cursor = "";
            setWaitingListBtnDisabled(false);
        }
        //}
    }

    const addContactOnWhise = async (body, uploadedFiles) => { // btnRef, => remove and it cursor progress
        try {
            if (clientToken != "") {
                let url = "https://api.whise.eu/v1/contacts/upsert";

                const config = {
                    headers: {
                        'Authorization': `Bearer ${clientToken}`,
                        'Content-Type': 'application/json'
                    },
                };

                const response = await axios.post(url, body, config);

                if (response.data.contactId > 0) {

                    const contactDetailObj = {
                        contactId: response.data.contactId,
                        contactBody: body,
                        uploadFiles: uploadedFiles
                    }

                    setContactDetailForAgainEventCreate(contactDetailObj);

                    if (isAutomaticSlotAccept == "true") { // replace with new condition "officeSetting.automaticSlotAcceptation"

                        //let contactTitleId = typeof selectedTitle == "number" ? selectedTitle : selectedTitle?.value ?? null;

                        let contactTitle = selectedTitle != null ? typeof selectedTitle == "number" ? { "id": selectedTitle } : (selectedTitle.value != undefined && selectedTitle.value != null) ? { "id": selectedTitle.value } : null : null;

                        let contactObj = {
                            "contactId": response.data.contactId,
                            "name": body.Name,
                            "firstName": body.FirstName,
                            "contactTitle": contactTitle, //{ "id": contactTitleId },
                            "country": { "id": 1 },
                            "languageId": body.LanguageId,
                            "privateMobile": body.PrivateMobile,
                            "privateEmail": body.PrivateEmail,
                            "agreementEmail": true,
                            "agreementSms": true,
                            "funnelStatusId": 3,
                            "attendeeStatus": { "id": 1 }
                        }

                        // get object "question/answer and upload doucments"
                        let getContactQuesDocUploadDetailObj = contactQuesDoucUploadDetailObj(estateconfigurations, uploadedFiles, agentLanguage);

                        // set event id fellow to syncEventToWhise value check from local db in setting table
                        //let eventId = officeSetting.syncEventsToWhise ? { eventId: +eventSlot.whiseEventId } : { eventId: +eventSlot.id }

                        // payload for API "TBC to Confirmed event"
                        let freeSlotToConfirmEventbody = {
                            "clientId": +clientId,
                            "estateId": estate.id,
                            "contactId": response.data.contactId,
                            "whiseEventId": eventSlot.whiseEventId,
                            "officeId": +officeId,
                            "agentId": eventSlot.users[0].userId,
                            "contactObj": contactObj,
                            "ContactQaDocDetail": getContactQuesDocUploadDetailObj,
                            "eventId": +eventSlot.id,
                            "freeSlotToConfirmed": true,
                        }
                        console.log(freeSlotToConfirmEventbody);
                        // TBC to Confirmed event API
                        const getEventStatusFreeSlotToConfirmEvent = await freeSlotEventToConfirmEventHandling(freeSlotToConfirmEventbody);

                        if (getEventStatusFreeSlotToConfirmEvent.type == "success") {
                            const sendEmailToAgent = await sendEmailToAgentFreeSlotToConfirmedEvent(uploadedFiles);
                            if (sendEmailToAgent.resp != "Email Sent successfully") {
                                // sent error email to agent and hamza
                                await agentEmailNotSentInfoToClient(eventSlot.whiseEventId, estate.id, sendEmailToAgent.agentEmail, eventSlot.startDateTime, eventSlot.endDateTime, agentLanguageTranslation);
                            }
                            addBookingSiteLandedLogsSaveInDB(); // add landed page logs dump in db
                            setFormStep(3);
                            setWaitingListBtnDisabled(false);
                            resetSelectedSlot();
                            emailSentRef.current = true;
                            setEmailSendStatus(true);
                            return;
                        } else {
                            addBookingSiteLandedLogsSaveInDB(); // add landed page logs dump in db
                            setWaitingListBtnDisabled(false);
                            resetSelectedSlot();
                            emailSentRef.current = true;
                            setEmailSendStatus(true);
                            //setFormStep(3);
                            handleModalClsoe();
                            return;
                        }
                    }

                    if (officeSetting.syncEventsToWhise == false) {
                        localFreeSlotAddTobeConfirmedWhiseEvent(response.data.contactId, body, uploadedFiles); // btnRef, => remove
                    }
                    else {
                        deleteFreeSlotAddTobeConformWhiseCalenerEvent(response.data.contactId, body, uploadedFiles); // btnRef, => remove
                    }
                }
            }
        } catch (error) {
            console.log("error", error);
        }
    }

    const checkEventOnStartDateTimeAlreadyExistInDB = async (eventSlot) => {

        // event time not check from local db if user account type "SystemIntegrator", same event time return
        if (userAccountType == variables.UserAccountTypeIdentity) { // "SystemIntegrator"

            const eventDateTime = {
                eventStartDateTime: eventSlot.startDateTime,
                eventEndDateTime: eventSlot.endDateTime,
                status: false
            }

            return eventDateTime;
        }


        let increment = 0; //30;
        let currentEventStartDateTime = new Date(eventSlot.startDateTime);
        let currentEventEndDateTime = new Date(eventSlot.endDateTime);
        let firstCall = false;

        while (true) {
            // currentEventStartDateTime = new Date(currentEventStartDateTime.getTime() + increment * 1000);
            let formattedStartDateTime = currentEventStartDateTime.toLocaleString('sv-SE').replace(' ', 'T');

            //currentEventEndDateTime = new Date(currentEventEndDateTime.getTime() + increment * 1000);
            let formattedEndDateTime = currentEventEndDateTime.toLocaleString('sv-SE').replace(' ', 'T');

            try {
                let url = `${variables.API_URL}LocalEvents/CheckEventsFromDbBasesOnTime?estateId=${eventSlot.estateId}&calendarActionId=${eventSlot.calenderActionId}&agentId=${eventSlot.agentId}&startDateTime=${formattedStartDateTime}&endDateTime=${formattedEndDateTime}`;

                const response = await axios.get(url);
                console.log(response.data);

                if (response.data == true) {
                    // after first call, increase by second
                    increment = firstCall ? 1 : 30;
                    firstCall = true;

                    currentEventStartDateTime = new Date(currentEventStartDateTime.getTime() + increment * 1000);
                    currentEventEndDateTime = new Date(currentEventEndDateTime.getTime() + increment * 1000);

                } else if (response.data == false) {

                    const eventDateTime = {
                        eventStartDateTime: formattedStartDateTime,
                        eventEndDateTime: formattedEndDateTime,
                        status: response.data
                    }

                    return eventDateTime;
                    // break;
                }
            } catch (error) {
                console.log("error:", error);
                setWaitingListBtnDisabled(false);
                break;
            }
        }
    }

    const localFreeSlotAddTobeConfirmedWhiseEvent = async (contactId, contactBody, uploadedFiles) => { // fucntion wrong name use already exist but I change fucntionality // btnRef,

        let address = "";
        address += estate.address == undefined ? "" : estate.address + " ";
        address += estate.number == undefined ? "" : estate.number + ", ";
        address += estate.zip == undefined ? "" : estate.zip;
        address += estate.city == undefined ? "" : " " + estate.city;

        let calenderActionId;

        if (isAutomaticSlotAccept == "true") { // replace with new condition "officeSetting.automaticSlotAcceptation"
            calenderActionId = callbackGetToBeConfirmedIds(estate.purpose.id, "confirm");
        } else {
            calenderActionId = callbackGetToBeConfirmedIds(estate.purpose.id, "tobeconfirm");
        }
        //let toBeConfirmedId = callbackGetToBeConfirmedIds(estate.purpose.id);

        const configEventBodyDetailObj = {
            startDateTime: eventSlot.startDateTime,
            endDateTime: eventSlot.endDateTime,
            agentId: eventUser.id,
            estateId: estate.id,
            calenderActionId: calenderActionId
        }

        // event time not check from local db if user account type "SystemIntegrator", fun same event time return
        const checkEventIsAlreadyExistInDB = await checkEventOnStartDateTimeAlreadyExistInDB(configEventBodyDetailObj);

        let action = calendarActions.filter(item => {
            return item.id == calenderActionId;
        })

        let subject = action[0].name + ": " + address + " " + contactBody.FirstName + " " + contactBody.Name;

        // contact question and answer setup
        let contactQuesAnsUploadDetail = estateconfigurations != null && estateconfigurations.questions.length > 0 ?
            estateconfigurations.questions.filter(item => item.answerText !== undefined && item.answerText != "")
                .map(item => {
                    const qObj = JSON.parse(item.questionDetail);
                    let lang = agentLanguage || "fr-BE";
                    return {
                        question: qObj[`questionTitle-${lang}`], // dynamic key
                        answerText: item.answerText
                    }
                })
            :
            [];

        // contact Document upload
        let contactDocUploadDetail = uploadedFiles.urls.length > 0 ?
            uploadedFiles.urls
                .map((item, index) => {
                    return {
                        title: `Doc${index + 1}`, // dynamic key
                        url: item
                    }
                })
            :
            [];

        const contactQuesDocUploadDetailObj = {
            Question: contactQuesAnsUploadDetail,
            documents: contactDocUploadDetail
        }

        // convert question and answer into string
        let conatactQuestionAnswerString = contactQuesAnsUploadDetail.map((item, i) => `Q${i + 1}: ${item.question}\nA${i + 1}: ${item.answerText}`).join('\n').slice(0, 2990);

        let configration = {
            "StartDateTime": checkEventIsAlreadyExistInDB.eventStartDateTime, //eventSlot.startDateTime,
            "EndDateTime": checkEventIsAlreadyExistInDB.eventEndDateTime, // eventSlot.endDateTime,
            "AllDay": false,
            "Private": false,
            "subject": subject,
            "UserIds": [eventUser.id], //eventSlot.users[0].userId
            "EstateIds": [estate.id],
            "ContactIds": [contactId],
            "Description1": eventSlot.description1 == "SmartCalendar Db Event" ? `${eventSlot.description1}{${eventSlot.id}}` : eventSlot.description1,
            "Description2": conatactQuestionAnswerString,
        }
        configration["CalendarActionId"] = calenderActionId;
        if (eventSlot.pattern) {
            configration["Pattern"] = eventSlot.pattern;
            configration["PatternEndDate"] = eventSlot.patternEndDate;
        }

        addWhiseCalenderEvent(configration, contactId, contactBody, uploadedFiles, contactBody.FirstName, contactQuesDocUploadDetailObj); // btnRef, => remove , contactBody.Name
    }

    const deleteFreeSlotAddTobeConformWhiseCalenerEvent = async (contactId, contactBody, uploadedFiles) => { // btnRef, => remove

        try {
            //let url = "https://api.whise.eu/v1/calendars/delete";
            //let headers = {
            //    'Authorization': `Bearer ${clientToken}`,
            //    'Content-Type': 'application/json'
            //};

            //let body = {
            //    "CalendarIds": [eventSlot.whiseEventId]
            //};

            //if (eventSlot.whiseEventId != null) {
            //    const response = await axios.delete(url, { data: body, headers: headers });
            //    const deletEventStatus = response.data;
            //}

                parent();
                let address = "";
                address += estate.address == undefined ? "" : estate.address + " ";
                address += estate.number == undefined ? "" : estate.number + ", ";
                address += estate.zip == undefined ? "" : estate.zip;
                address += estate.city == undefined ? "" : " " + estate.city;

                let calenderActionId;

                if (isAutomaticSlotAccept == "true") { // replace with new condition "officeSetting.automaticSlotAcceptation"
                    calenderActionId = callbackGetToBeConfirmedIds(estate.purpose.id, "confirm");
                } else {
                    calenderActionId = callbackGetToBeConfirmedIds(estate.purpose.id, "tobeconfirm");
                }
                //let toBeConfirmedId = callbackGetToBeConfirmedIds(estate.purpose.id);

                const configEventBodyDetailObj = {
                    startDateTime: eventSlot.startDateTime,
                    endDateTime: eventSlot.endDateTime,
                    agentId: eventUser.id,
                    estateId: estate.id,
                    calenderActionId: calenderActionId
                }

                // event time not check from local db if user account type "SystemIntegrator", fun same event time return
                const checkEventIsAlreadyExistInDB = await checkEventOnStartDateTimeAlreadyExistInDB(configEventBodyDetailObj);

                let action = calendarActions.filter(item => {
                    return item.id == calenderActionId;
                })

                let subject = action[0].name + ": " + address + " " + contactBody.FirstName + " " + contactBody.Name;

                // contact question and answer setup
                let contactQuesAnsUploadDetail = estateconfigurations != null && estateconfigurations.questions.length > 0 ?
                    estateconfigurations.questions.filter(item => item.answerText !== undefined && item.answerText != "")
                    .map(item => {
                        const qObj = JSON.parse(item.questionDetail);
                        let lang = agentLanguage || "fr-BE";
                        return {
                            question: qObj[`questionTitle-${lang}`], // dynamic key
                            answerText: item.answerText
                        }
                    })
                    : 
                    [];

                // contact Document upload
                let contactDocUploadDetail = uploadedFiles.urls.length > 0 ?
                    uploadedFiles.urls
                        .map((item, index )=> {
                            return {
                                title: `Doc${index + 1}`, // dynamic key
                                url: item
                            }
                        })
                    :
                    [];

                const contactQuesDocUploadDetailObj = {
                    Question: contactQuesAnsUploadDetail,
                    documents: contactDocUploadDetail
                }

                // convert question and answer into string
                let conatactQuestionAnswerString = contactQuesAnsUploadDetail.map((item, i) => `Q${i + 1}: ${item.question}\nA${i + 1}: ${item.answerText}`).join('\n').slice(0, 2990);

                let configration = {
                    "StartDateTime": checkEventIsAlreadyExistInDB.eventStartDateTime, //eventSlot.startDateTime,
                    "EndDateTime": checkEventIsAlreadyExistInDB.eventEndDateTime, //eventSlot.endDateTime,
                    "AllDay": false,
                    "Private": false,
                    "subject": subject,
                    "UserIds": [eventUser.id], //eventSlot.users[0].userId
                    "EstateIds": [estate.id],
                    "ContactIds": [contactId],
                    "Description2": conatactQuestionAnswerString,
                }
                configration["CalendarActionId"] = calenderActionId;
                if (eventSlot.pattern) {
                    configration["Pattern"] = eventSlot.pattern;
                    configration["PatternEndDate"] = eventSlot.patternEndDate;
                }

                addWhiseCalenderEvent(configration, contactId, contactBody, uploadedFiles, contactBody.FirstName, contactQuesDocUploadDetailObj); // btnRef, => remove , contactBody.Name

        } catch (error) {
            console.log("error", error)
        }
    }

    const addWhiseCalenderEvent = async (body, contactId, contactBody, uploadedFiles, contactFirstName, eventQuestionAnswer) => { // btnRef, => remove
        try {
            let url = "";
            let config = null;

            // whise event create flow to user account type
            if (userAccountType == variables.UserAccountTypeIdentity) {
                url = "https://api.whise.eu/v1/calendars/create";

                config = {
                    headers: {
                        'Authorization': `Bearer ${clientWhiseTokenByUserAccountType}`,
                        'Content-Type': 'application/json'
                    },
                };
            } else {
                url = "https://api.whise.eu/v1/calendars/upsert";

                config = {
                    headers: {
                        'Authorization': `Bearer ${clientToken}`,
                        'Content-Type': 'application/json'
                    },
                };
            }

            const response = await axios.post(url, body, config)

            let getNewWhiseEventId = response.data.calendarId;

            // TBC event not create due to "Description2" length/text
            if (response.data.calendarId == undefined && response.data.isValidRequest == false) {

                // error email send if calendar/create api failed
                if (userAccountType == variables.UserAccountTypeIdentity) {
                    const eventDetail = {
                        clientId: clientId,
                        reason: JSON.stringify(response.data),
                        eventDetail: body
                    }
                    sendCalendarCreateApiErrorEmail("en-GB", eventDetail);
                }


                if (response.data.validationErrors[0].property == "Description2") {
                    body.Description2 = "";

                    // whise event create flow to user account type
                    if (userAccountType == variables.UserAccountTypeIdentity) {
                        getNewWhiseEventId = await addNewWhiseEventByAccountType(clientWhiseTokenByUserAccountType, body);
                    } else {
                        getNewWhiseEventId = await addNewWhiseEventOnWhise(clientToken, body);
                    }
                }
            }

            const newWhiseCalenderEvent = await getWhiseCalenderEventByWhiseEventId(getNewWhiseEventId); //response.data.calendarId

            const eventDetailObj = {
                contactId: contactId,
                contactBody: contactBody,
                uploadedFiles: uploadedFiles,
                whiseEventId: getNewWhiseEventId, //response.data.calendarId
                eventBody: body
            }

            const getUniqueNewWhiseEventId = await checkEventAlreadyExistInDB(eventDetailObj);

            const updateLocalDB = await updateEventDetailInDB(newWhiseCalenderEvent, body, getUniqueNewWhiseEventId, eventQuestionAnswer);

            // if local db not update then email's not send to agent and contact
            if (updateLocalDB.toLowerCase() !== "event is updated successfully") {

                let eventDetail = {
                    whiseEventId: getNewWhiseEventId,
                    eventBody: body
                }

                // TBC event delet from whise calendar
                whiseEventDeletFromWhise(clientToken, getNewWhiseEventId);

                // send error email to client
                sendErrorEmailToClient(agentLanguageTranslation, eventDetail);

                // send error email to developer
                //sendErrorEmailToDeveloper(agentLanguageTranslation, eventDetail);

                setTbcEventNotUpdate(true);
                setFormStep(3);
                setWaitingListBtnDisabled(false);
                resetSelectedSlot();
                emailSentRef.current = true;
                setEmailSendStatus(true);
                return;
            }

            // free slot event delete on whise calendar
            if (eventSlot.whiseEventId != null) {
                whiseEventDeletFromWhise(clientToken, +eventSlot.whiseEventId);
            }

            let call1;
            let call2;

            if (emailSendStatus == true || emailSentRef.current) {
                return
            }

            if (isAutomaticSlotAccept == "true") { // replace with new condition "officeSetting.automaticSlotAcceptation"
                call1 = sendEmailToContactConfirmedSlot(body, newWhiseCalenderEvent);  //email to contact confirmed slot
                call2 = sendEmail(getNewWhiseEventId, contactId, contactBody.Name, uploadedFiles, contactFirstName, getUniqueNewWhiseEventId);    //email to agent
            } else {
                call1 = sendEmailToContact();  //email to contact
                call2 = sendEmail(getNewWhiseEventId, contactId, contactBody.Name, uploadedFiles, contactFirstName, getUniqueNewWhiseEventId);    //email to agent
            }

            Promise.all([call1, call2]).then(() => {
                //setFormStep(4);
                addBookingSiteLandedLogsSaveInDB(); // add landed page logs dump in db
                setFormStep(3);
                setWaitingListBtnDisabled(false);
                resetSelectedSlot();
                emailSentRef.current = true;
                setEmailSendStatus(true);
            });

            //const emailTempleteObj = {
            //    notificationRequest: "pendingRequestNotification",
            //    estate: estate,
            //    validRequest: "onHold" //
            //}

            //sendCancelledVisitEmailToContact(emailTempleteObj);

        } catch (error) {
            console.log("error", error);

            // error email send if calendar/create api failed
            if (userAccountType == variables.UserAccountTypeIdentity) {
                const eventDetail = {
                    clientId: clientId,
                    reason: JSON.stringify(error),
                    eventDetail: body
                }
                sendCalendarCreateApiErrorEmail("en-GB", eventDetail);
            }
        }
    }

    const checkEventAlreadyExistInDB = async (newEventDetailObj) => {
        try {
            let eventStartDateTime = new Date(newEventDetailObj.eventBody.StartDateTime);
            let eventEndDateTime = new Date(newEventDetailObj.eventBody.EndDateTime);
            let newWhiseEventId = newEventDetailObj.whiseEventId;
            let shouldSendEmail = true; // track if email should be sent

            for (let iteration = 0; iteration < 2; iteration++) {
                let url = `${variables.API_URL}LocalEvents/CheckWhiseEventIdExistanceInDB?whiseEventId=${newWhiseEventId}`;
                const response = await axios.get(url);

                //iterationCount = iteration;
                if (response.data === false) {
                    shouldSendEmail = false; // stop not send email

                    const eventDetailObj = {
                        newWhiseEventId: newWhiseEventId,
                        eventStatus: false
                    }

                    return eventDetailObj; //false; // loop stop
                }

                //await whiseEventDeletFromWhise(clientToken, newWhiseEventId); // delet new confirmed whise event

                if (iteration == 0) {
                    // after first call, only increase by 1 second
                    eventStartDateTime = new Date(eventStartDateTime.getTime() + 1000);
                    eventEndDateTime = new Date(eventEndDateTime.getTime() + 1000);

                    const checkStartEndTimeFromDBobj = {
                        startDateTime: eventStartDateTime,
                        endDateTime: eventEndDateTime,
                        estateId: newEventDetailObj.eventBody.EstateIds[0],
                        agentId: newEventDetailObj.eventBody.UserIds[0],
                        calenderActionId: newEventDetailObj.eventBody.CalendarActionId,
                    }

                    const getUniqueEventStartEndTime = await checkEventStartEndTimeFromDBisAlreadyExist(checkStartEndTimeFromDBobj);

                    //console.log(getUniqueEventStartEndTime);

                    newEventDetailObj.eventBody.StartDateTime = getUniqueEventStartEndTime.eventStartDateTime; //eventStartDateTime;
                    newEventDetailObj.eventBody.EndDateTime = getUniqueEventStartEndTime.eventEndDateTime; //eventEndDateTime;

                    // whise event create flow to user account type
                    if (userAccountType == variables.UserAccountTypeIdentity) {
                        newWhiseEventId = await addNewWhiseEventByAccountType(clientWhiseTokenByUserAccountType, newEventDetailObj.eventBody);
                    } else {
                        newWhiseEventId = await addNewWhiseEventOnWhise(clientToken, newEventDetailObj.eventBody); // add new whise event
                    }
                }
            }

            if (shouldSendEmail) {
                sendEmailToClientForDuplicateWhiseEvent(newEventDetailObj.eventBody); // send email to client if whise event id is exist in local db
            }

            const eventDetailObj = {
                newWhiseEventId: newWhiseEventId,
                eventStatus: shouldSendEmail
            }

            return eventDetailObj; //shouldSendEmail;

        } catch (err) {
            console.log(err);
            expectionLoging(`Error in api: check whise event is already exist: ${err}`);
        }
    }

    const getWhiseCalenderEventByWhiseEventId = async (whiseEventId) => {
        try {
            let url = "https://api.whise.eu/v1/calendars/list";
            const config = {
                headers: {
                    'Authorization': `Bearer ${clientToken}`,
                    'Content-Type': 'application/json'
                },
            };
            let body = {
                "Filter": {
                    "CalendarIds": [whiseEventId]
                }
            };
            let response = await axios.post(url, body, config)
            const result = response.data.calendars;
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    const updateEventDetailInDB = async (newWhiseEventDetail, eventBody, whiseEventIdStatus, eventQuestionAnswer) => {
        let body;
        try {
            let url = `${variables.API_URL}LocalEvents/UpdateEventInDatabase`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            // get calender action id base on estate purpose
            //const eventCalanderActionId = estate.purpose.id == 2 ? officeSetting.visitToRentBefore : officeSetting.visitToSaleBefore;

            // filter current contact from event
            //const filterCurrentContact = newWhiseEventDetail[0].contacts.filter(contactItem => contactItem.privateEmail == email);
            //console.log(eventQuestionAnswer);

            let contactTitle = selectedTitle != null ? typeof selectedTitle == "number" ? { "id": selectedTitle } : (selectedTitle.value != undefined && selectedTitle.value != null) ? { "id": selectedTitle.value } : null  : null  //typeof selectedTitle == "number" ? selectedTitle : selectedTitle?.value ?? null;

            let contactObj = {
                "contactId": eventBody.ContactIds[0],
                "name": name,
                "firstName": firstName,
                "contactTitle": contactTitle, //{ "id": contactTitleId },
                "country": { "id": 1 },
                "languageId": selectedLanguage,
                "privateMobile": mobile,
                "privateEmail": email,
                "agreementEmail": true,
                "agreementSms": true,
                "funnelStatusId": 3,
                "attendeeStatus": { "id": 1 }
            }

            body = {
                id: eventSlot.id,
                oldWhiseEventId: eventSlot.whiseEventId,
                newWhiseEventId: whiseEventIdStatus.eventStatus === true ? null : whiseEventIdStatus.newWhiseEventId, //newWhiseEventDetail[0].id,
                calendarActionId: eventBody.CalendarActionId, //newWhiseEventDetail[0].action.id,
                subject: eventBody.subject,
                actionType: "toBeConfirmed",
                eventStartDateTime: eventBody.StartDateTime,
                eventEndDateTime: eventBody.EndDateTime,
                contacts: [contactObj], //filterCurrentContact, //
                newContactId: null,
                oldContactId: `${eventBody.ContactIds[0]}`,
                clientId: +clientId,
                eventQaDetails: eventQuestionAnswer
            }
            //console.log(body);
            const response = await axios.post(url, body, config);
            if (response.data) {
                updateEstateStatusInDB();
                if (response.data.toLowerCase() !== "event is updated successfully") {
                    expectionLoging(`Update local db api: ${response.data} ${JSON.stringify(body)}`);
                }
                return response.data;
            }
        } catch (error) {
            console.log("event update in db:", error);
            expectionLoging(`Error-update local db api: ${error} ${JSON.stringify(body)}`);
            return "ErrorUpdateLocaldbApi";
        }

    }

    const updateEstateStatusInDB = async (newWhiseEventDetail) => {
        try {
            let url = `${variables.API_URL}LocalEvents/UpdateEstateStatus`;
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const body = {
                estateId: estate.id,
                clientId: +clientId
            }

            const response = await axios.post(url, body, config);
            // console.log(response);

        } catch (error) {
            console.log("event update in db:", error);
        }
    }

    const sendEmail = async (eventId, contactId, contactName, uploadedFiles, contactFirstName, whiseEventStatus) => {
        let agentEmail = "";
        try {
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            //let subject = "Please Confirm the Booking";

            eventId = whiseEventStatus.eventStatus === true ? 0 : whiseEventStatus.newWhiseEventId;

            let contactFirstName = "cFirstName";
            let contactLastName = "cLastName";

            let externalUrl = variables.AgentSiteURL + "eventhandler/" + contactId + "/" + eventId + "/" + clientId + "/" + officeId + "/" + contactFirstName + "/" + contactLastName + "/" + selectedLanguage + "/" + estate.id + "/" + eventUser.id + "/" + eventSlot.id;
            let refuseBtnExternalUrl = variables.AgentSiteURL + "eventdenialhandler/" + contactId + "/" + eventId + "/" + clientId + "/" + officeId + "/" + contactLastName + "/" + selectedLanguage + "/" + estate.id + "/" + eventUser.id + "/" + eventSlot.id;

            //let externalUrl = variables.AgentSiteURL + "eventhandler/" + contactId + "/" + eventId + "/" + clientId + "/" + officeId + "/" + contactFirstName + "/" + contactName + "/" + selectedLanguage + "/" + estate.id + "/" + eventUser.id + "/" + eventSlot.id;
            //let refuseBtnExternalUrl = variables.AgentSiteURL + "eventdenialhandler/" + contactId + "/" + eventId + "/" + clientId + "/" + officeId + "/" + contactName + "/" + selectedLanguage + "/" + estate.id + "/" + eventUser.id + "/" + eventSlot.id;
            //console.log(externalUrl);
            //console.log(refuseBtnExternalUrl);
            const startEventDate = new Date(eventSlot.startDateTime);
            const clientLanguage = clientSettings.defaultLanguageId;
            //console.log(estateconfigurations);
            let questionsHtml = "";
            if (estateconfigurations != null && estateconfigurations.questions != undefined && estateconfigurations.questions.length > 0) {
                let lastIndex = estateconfigurations.questions.length - 1
                estateconfigurations.questions.forEach((item, i) => {
                    if (item.answerText != undefined && item.answerText != "") {
                        let questionDetail = JSON.parse(item.questionDetail);
                        let title = questionDetail[`questionTitle-${agentLanguage}`]; // replace clientSettings.defaultLanguageId with agentLanguage
                        if (i == lastIndex) {
                            questionsHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; padding: 16px;margin-top: 0;'>";
                        }
                        else {
                            questionsHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; margin-bottom: 16px;margin-top: 0;padding: 16px;'>";
                        }
                        questionsHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                        questionsHtml += "            " + title + "";
                        questionsHtml += "        </p>";
                        questionsHtml += "        <p style='padding: 0px 12px;font-family:Roboto;font-size: 14px;color:#111827;text-align:left;margin-bottom:0;border: 1px solid #E9EAEC;border-radius: 10px; height: 52px;line-height: 53px;background-color: white;'>";
                        questionsHtml += "        " + item.answerText + "";
                        questionsHtml += "        </p>";
                        questionsHtml += "    </div>";
                    }
                });
            }

            let documentHtml = "";
            if (estateconfigurations != null && estateconfigurations.requiredDocuments != undefined && estateconfigurations.requiredDocuments.length > 0 && (estateconfigurations.inviteeConfig.Documents == true || estateconfigurations.inviteeConfig.documents == true)) {
                estateconfigurations.requiredDocuments.forEach((item, i) => {
                    let lastIndex = estateconfigurations.requiredDocuments.length - 1;

                    const findDocFileNo = Object.keys(selectedFiles).map(Number);
                    let docuUrl = "";
                    let fileName = "";
                    let finalDocURL = "";
                    let origin = "";
                    // console.log(item.documentImageUrl);
                    if (findDocFileNo.indexOf(item.id) >= 0) {
                        let _fileName = selectedFiles[`${item.id}`].name.replaceAll("_", "-"); //get selected file name from state
                        if (uploadedFiles && uploadedFiles.urls.length > 0) {
                            uploadedFiles.urls.forEach(url => {
                                let extractedFileName = url.split("UploadedFiles/")[1];
                                let splittedName = extractedFileName.split("_")[1];
                                if (splittedName == _fileName) {
                                    origin = variables.API_URL.split("api/")[0];
                                    fileName = extractedFileName;
                                    finalDocURL = origin + "UploadedFiles/" + extractedFileName;
                                }
                            })
                        }
                    }

                    if (waitingListContactDetail != null && iframe == "waiting-list") {
                        origin = variables.API_URL.split("api/")[0];
                        fileName = item.documentImageUrl ? item.documentImageUrl.substring(item.documentImageUrl.lastIndexOf('/') + 1) : ""; //.substring(item.imageUrl.lastIndexOf('/') + 1);
                        finalDocURL = `${origin}UploadedFiles/${fileName}` //item.documentImageUrl;
                    }

                    let documentTitle = item.isManualName == true ?
                        item.manualDocumentName
                        :
                        item.documentTypeId == 1 ?
                            agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalIdCardOptionForBooking"] : "ID card"
                            :
                            item.documentTypeId == 2 ?
                                agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalPaySlipOptionForBooking"] : "Pay slip"
                                :
                                item.documentTypeId == 3 ?
                                    agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalBankStatementOptionForBooking"] : "Bank statement"
                                    :
                                    item.documentTypeName;

                    if (i == lastIndex) {
                        documentHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; padding: 16px;margin-top: 0;'>";
                    }
                    else {
                        documentHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; margin-bottom: 16px;margin-top: 0;padding: 16px;'>";
                    }
                    documentHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                    documentHtml += "            " + documentTitle + "";
                    documentHtml += "        </p>";
                    documentHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                    documentHtml += `           <a href="${finalDocURL}" target="_blank">${fileName}</a>`;
                    documentHtml += "        </p>";
                    documentHtml += "   </div>"
                })
            }

            let html = "";
            html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px auto; font-family: Roboto;'>";
            html += "   <tr>";
            html += "       <td style='text-align: center; padding: 30px 0px 50px 0px;'>";
            if (officeLogoUrl) {
                html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
            } else if (clientSettings != null && clientSettings.logoUrl != undefined) {
                html += "   <img src='" + clientSettings.logoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
            } else {
                html += "   <img src='" + variables.AgentSiteURL + "assets/logo-placeholder.png' width='200' style='margin: 0 auto; display: block;' />";
            }
            html += "       </td>";
            html += "   </tr>";
            html += "   <tr>";
            html += "       <td style='padding: 0 20px 15px 20px;'>";
            html += `           <h5 style='font-size: 20px; font-weight: 500;color: #111827; font-family: Roboto; margin: 0px; text-align: center; line-height: 1.3;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailHeading"] : "A Visit request has been booked trough the SmartCalendar online visit planner for (see below details)"}</h5>`;
            html += "       </td>";
            html += "   </tr>";

            if (isAutomaticSlotAccept == "false") { // replace with new condition "officeSetting.automaticSlotAcceptation"

                html += "<tr>";
                html += "   <td align='center' style='padding: 0 20px 50px 20px; text-align: center;'>";
                html += "       <table role='presentation' cellspacing='0' cellpadding='0' style='display: inline-block;'>";
                html += "           <tr>";

                html += "               <td style='padding-right: 10px;'>";
                html += "                   <table role='presentation' cellspacing='0' cellpadding='0' style='display: inline-table;'>";
                html += "                       <tr>";
                html += "                           <td style='padding: 12px 20px; border: 1px solid #111827; border-radius: 10px;'>";
                html += `                               <a href='${refuseBtnExternalUrl}' style='color: #111827; text-decoration: none; font-size: 14px; display: inline-block;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailRefuseBtnLabel"] : "Refuse"}</a>`;
                html += "                           </td>";
                html += "                       </tr>";
                html += "                   </table>";

                html += "               <td>";
                html += "                   <table role='presentation' cellspacing='0' cellpadding='0' style='display: inline-table;'>";
                html += "                       <tr>";
                html += "                           <td style='padding: 12px 20px; background-color: #274B97; border-radius: 10px;'>";
                html += `                               <a href='${externalUrl}' style='color: white; text-decoration: none; font-size: 14px; display: inline-block;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailAcceptBtnLabel"] : "Accept"}</a>`;
                html += "                           </td>";
                html += "                       </tr>";
                html += "                   </table>";
                html += "               </td>";
                html += "           </tr>";
                html += "       </table>";
                html += "   </td>";
                html += "</tr>";

            }

            html += "   <tr>";
            html += "       <td style='text-align: start; padding: 0 20px 10px 20px;'>";
            html += `           <p style='font-size: 14px; font-weight: 600; color: #111827;font-family: Roboto; text-align: left; margin: 0px; '>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailResumeHeading"] : "RESUME OF THE VISIT REQUEST"}</p>`;
            html += "       </td>";
            html += "   </tr>";
            html += "<tr>";
            html += "   <td style='text-align: center; padding: 0px 20px 30px 20px;'>";
            html += "       <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px;'>";
            html += "        <tbody>";
            html += "           <tr>";
            html += "               <td style='padding: 20px;'>";
            html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailDateTitle"] : "Date"}</h5>`;
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px;'>" + formatDateTimeLanguageSpecific(agentLanguage != null ? agentLanguage : clientLanguage, eventSlot.startDateTime) + "</p>";
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += "                   <hr>";
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailEstateHeading"] : "Property"}</h5>`;
            html += "               </td>";
            html += "           </tr>";

            html += "           <tr>";
            html += "               <td style='padding: 0 20px;'>";
            html += "                   <div style='float: left;'>";
            if (estate.pictures != undefined && estate.pictures.length > 0 && estate.pictures[0].urlLarge != undefined) {
                html += "                   <img src='" + estate.pictures[0].urlLarge + "' className='rounded-4' width='170' alt='house image' />";
            }
            html += "                   </div>";
            html += "                   <div style='float: left; padding-left: 20px'>";
            if (estate.name != undefined) {
                html += "                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;'> " + estate.name + " </h5>";
            } else {
                html += " ";
            }
            html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0; vertical-align: text-top;'>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/location-pin.png' width='15' style='vertical-align: text-top;' />";
            html += "                           &nbsp;" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city);
            html += "                       </p>";

            html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;vertical-align: middle;'>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/bed-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bedRooms == undefined ? "" : estate.bedRooms} </span>`;
            html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/shower-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bathRooms == undefined ? "" : estate.bathRooms}</span>`;
            html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/lift-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.area == undefined ? "" : estate.area}</span>`;
            html += "                       </p>";
            html += "                    </div>";
            html += "               </td>";
            html += "           </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 20px;'>";
            html += "                       <hr>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += `                       <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailContactsHeading"] : "Contacts"}</h5>`;
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 5px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + firstName + " " + name + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 5px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + email + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + mobile + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       <hr>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       " + questionsHtml + "";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       " + documentHtml + "";
            html += "                   </td>";
            html += "               </tr>";
            html += "               </tbody>";
            html += "           </table>";
            html += "       </td>";
            html += "   </tr>";
            html += "</table>";

            // replace with new condition "officeSetting.automaticSlotAcceptation"
            let subject = isAutomaticSlotAccept == "true" ? agentLanguageTranslation != null ? agentLanguageTranslation["agentDirectlyConfirmedEmailSubjectLbl"] : "Smartcalendar : A new visit has been added to your calendar" : agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailSubject"] : "Please Confirm the Booking";
            let sendTo = "";

            if (officeSetting.isVisitRequestManagementEnabled && officeSetting.reqManagementOfAgent && eventUser.id == officeSetting.reqManagementOfAgent) { // eventSlot.users[0].userId
                if (officeSetting.sendEmailTo == 2 && officeSetting.customEmail != "" && officeSetting.customEmail != null) {
                    sendTo = officeSetting.customEmail;
                } else if (officeSetting.sendEmailTo == 1 && whiseOffice.email != "") {
                    sendTo = whiseOffice.email;
                }
            }
            else if (officeSetting.isVisitRequestManagementEnabled && officeSetting.reqManagementOfAgent == null) {
                if (officeSetting.sendEmailTo == 2 && officeSetting.customEmail != "" && officeSetting.customEmail != null) {
                    sendTo = officeSetting.customEmail;
                } else if (officeSetting.sendEmailTo == 1 && whiseOffice.email != "") {
                    sendTo = whiseOffice.email;
                }
            }
            else {
                sendTo = eventUser.email; //eventSlot.users[0].email;
            }

            let objEmail = {
                emailTo: sendTo,
                body: html,
                subject: subject,
                emailType: "agent"
            }

            agentEmail = sendTo; // set agent email
            const url = variables.API_URL + `Email/SendEmail?`;
            
            const response = await axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers

            if (response.data) {
                if (response.data == "Email Sent successfully") {
                    console.log("Agent Email Sent successfully");
                } else {
                    // sent error email to agent and hamza => if TBC email can't sent to agent
                   agentEmailNotSentInfoToClient(eventSlot.whiseEventId, estate.id, sendTo, eventSlot.startDateTime, eventSlot.endDateTime, agentLanguageTranslation);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            // sent error email to agent and hamza => if TBC email can't sent to agent
           agentEmailNotSentInfoToClient(eventSlot.whiseEventId, estate.id, agentEmail, eventSlot.startDateTime, eventSlot.endDateTime, agentLanguageTranslation);
        }
    }

    const getWhiseCalenderEventById = async (filters) => {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };
        let body = {
            "Filter": filters
        };
        await axios.post(url, body, config)
            .then(response => {
                if (response.data.calendars) {
                    eventExist = true;
                } else {
                    eventExist = false;
                }

            })
            .catch(error => {
                console.log("error", error);
            });
    }

    const getLocalCalenderEventById = async (id) => {

        let url = variables.API_URL + `LocalEvents/GetLocalEventById?clientId=${clientId}&officeId=${officeId}&eventId=${id}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, {}, config);

        if (response.data && response.data.calendars) {
            eventExist = true;
        }
        else {
            eventExist = false;
        }
    }

    const onChangeMobileHandler = (e) => {
        let mobileNumber = "+" + e;
        removeValidationError("mobile")
        setMobile(mobileNumber);
    }

    const removeValidationError = (field) => {
        let errorMessages = [...requiredFieldMessage];

        if (field == "name") {
            setIsNameEmpty(false);
        }
        if (field == "firstName") {
            setIsFirstNameEmpty(false);
        }
        if (field == "email") {
            setIsEmailEmpty(false);
        }
        if (field == "mobile") {
            setIsMobileEmpty(false);
        }
        if (field == "contactTitle") {
            setIsTitleEmpty(false);
        }

        let mappedDocErrors = errorMessages.filter(item => {
            if (item.field != field) {
                return { ...item }
            }
        })
        setRequiredFieldMessage(mappedDocErrors);
    }

    const handleCheckBoxAnswerType = (questionId, answerId, answerText) => {
        let errorMessages = [...requiredFieldMessage];
        document.getElementById(`question${questionId}`).classList.remove("border-red");
        const updatedQuestions = estateconfigurations.questions.map((question) => {
            if (question.questionId === questionId) {
                return {
                    ...question,
                    answerId: answerId,
                    answerText: answerText
                };
            }
            return question;
        });

        setEstateConfigurations((prevData) => ({
            ...prevData,
            questions: updatedQuestions
        }));

        let mappedDocErrors = errorMessages.filter(item => {
            if (item.field != `question${questionId}`) {
                return { ...item }
            }
        })
        setRequiredFieldMessage(mappedDocErrors);
    };

    const handleFixCheckBoxAnswerType = (questionId, answerText) => {
        let errorMessages = [...requiredFieldMessage];
        document.getElementById(`question${questionId}`).classList.remove("border-red");
        const updatedQuestions = estateconfigurations.questions.map((question) => {
            if (question.questionId === questionId) {
                return {
                    ...question,
                    answerText: answerText
                };
            }
            return question;
        });

        setEstateConfigurations((prevData) => ({
            ...prevData,
            questions: updatedQuestions
        }));

        let mappedDocErrors = errorMessages.filter(item => {
            if (item.field != `question${questionId}`) {
                return { ...item }
            }
        })
        setRequiredFieldMessage(mappedDocErrors);
    };

    const handleTextBoxChangeAnswerType = (e, questionId) => {
        let value = e.target.value;
        let errorMessages = [...requiredFieldMessage];

        const updatedQuestions = estateconfigurations.questions.map((question) => {
            if (question.questionId === questionId) {
                return {
                    ...question,
                    answerText: value
                };
            }
            return question;
        });

        setEstateConfigurations((prevData) => ({
            ...prevData,
            questions: updatedQuestions
        }));

        if (value !== "") {
            document.getElementById(`question${questionId}`).classList.remove("border-red");

            let mappedDocErrors = errorMessages.filter(item => item.field !== `question${questionId}`);
            setRequiredFieldMessage(mappedDocErrors);
        }
    };

    // Trigger file selection for a specific document type
    const handleFileSelect = (e, docId) => {
        let errorMessages = [...requiredFieldMessage];

        const file = e.target.files[0];
        if (file) {
            setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [docId]: file // Store the file object for each document by ID
            }));
        }

        if (file) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [docId]: null
            }));
            let mappedDocErrors = errorMessages.filter(item => {
                if (item.field != `docType${docId}`) {
                    return { ...item }
                }
            })
            setRequiredFieldMessage(mappedDocErrors);
        }
    };

    // Function to trigger file upload for a specific document
    const handleUploadClick = (docId) => {
        document.getElementById(`fileInput-${docId}`).click();
    };

    // Send files to API on form submission
    const handleSubmit = async () => {
        // Create a FormData object to send the files
        const formData = new FormData();
        let docUrl = [];

        // Append each selected file to the FormData
        for (const [docId, file] of Object.entries(selectedFiles)) {
            formData.append("files", file);
            formData.append("fileName", file.name);
        }

        try {
            const url = variables.API_URL + `DocumentUpload/upload`;
            // Make the POST request using axios
            const response = await axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            //docUrl = response.data;
            return response.data;
            // You may update the UI or handle the response as needed
        } catch (error) {
            console.error("Upload error:", error);
        }
        return docUrl;
    };

    const getContactTitleList = () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";

        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${clientToken}`
        };

        let body = {};

        axios.post(url, body,
            {
                headers: headers
            })
            .then(response => {
                if (response.data) {
                    setContactTitleList(response.data.contactTitles);
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    useEffect(() => {
        if (showModal == true && prevSelectedEventSlot != null && eventSlot.id !== prevSelectedEventSlot.id) {
            setSelectedTitle(null);
            setName("");
            setEmail("");
            setFirstName("");
            setMobile("");
        }
    }, [showModal])

    useEffect(() => {
        if (formStep === 4) {
            setSelectedTitle(null);
            setName("");
            setEmail("");
            setFirstName("");
            setMobile("");
        }
    }, [formStep])

    const handleKeyDown = (e) => {
        // Prevent up and down arrow keys from modifying the value
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault();
        }
    };

    const resetAllFields = () => {
        setSelectedTitle(null);
        setName("");
        setEmail("");
        setFirstName("");
        setMobile("");
        setIsNameEmpty(false);
        setIsFirstNameEmpty(false);
        setIsEmailEmpty(false);
        setIsMobileEmpty(false);
        setIsTitleEmpty(false);
        setRequiredFieldMessage([]);
        setSelectedFiles({});
        setShowMessageIfAlreadyContactHavingEvents("");
        setErrors({});
        if (estateconfigurations != null && estateconfigurations.questions != undefined && estateconfigurations.questions.length > 0) {
            const updatedQuestions = estateconfigurations.questions.map((question) => {
                return {
                    ...question,
                    answerText: ""
                };
            });
            setEstateConfigurations((prevData) => ({
                ...prevData,
                questions: updatedQuestions
            }));
        }
    }

    const handleModalClsoe = () => {
        if (formStep == 1 || formStep == 2) {
            addBookingSiteLandedLogsSaveInDB();
        }
        resetAllFields(); // empty all fields of contact modal
        handleClose();
    }

    const handleMoveToPreviousScreen = () => {
        setFormStep(1);
    }
    function formatDateTimeLanguageSpecific(locale, dateStr) {
        const timeZones = {
            "en-US": "America/New_York",
            "en-GB": "Europe/London",
            "fr-FR": "Europe/Paris",
            "fr-BE": "Europe/Brussels",
            "nl-BE": "Europe/Brussels",
            "de-DE": "Europe/Berlin",
            "es-ES": "Europe/Madrid",
            "zh-CN": "Asia/Shanghai",
            "ja-JP": "Asia/Tokyo",
            "hi-IN": "Asia/Kolkata",
            "ru-RU": "Europe/Moscow",
            "ar-SA": "Asia/Riyadh",
            "pt-BR": "America/Sao_Paulo",
            "en-AU": "Australia/Sydney",
            "en-PK": "Asia/Karachi"
        }

        const eventDate = new Date(dateStr);

        // Extract local parts manually to avoid timezone conversions
        const year = eventDate.getFullYear();
        const month = eventDate.getMonth();
        const day = eventDate.getDate();
        const hours = eventDate.getHours();
        const minutes = eventDate.getMinutes();

        // Create a date object using UTC (so Intl won't shift it)
        const fixedDate = new Date(Date.UTC(year, month, day, hours, minutes));

        let clientLanguage = "fr-BE"; //  en-GB
        if (clientSettings != null && clientSettings.defaultLanguageId != undefined) {
            clientLanguage = clientSettings.defaultLanguageId;
        }

        const formatter = new Intl.DateTimeFormat(locale, {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,  // Change to true if you need 12-hour format
            timeZone: "UTC", //timeZones[clientLanguage], // Specify the desired timezone
            //timeZoneName: "long", // Change to true if you need 12-hour format
        });

        return formatter.format(fixedDate);
    }

    const handlerSelectContactTitle = (e) => {
        const selectedValue = e.target.value;
        const selectedItem = translatedTitles.find(item => item.value === +selectedValue);

        if (selectedItem) {
            setSelectedTitle(selectedItem);
        }
        removeValidationError("contactTitle");
    }

    useEffect(() => {
        if (selectedLanguage && contactTitles.length > 0) {
            let existingTitles = [...contactTitles];
            let titlesWithLanguageChange = existingTitles.map(item => {
                let description = "";
                if (selectedLanguage == "nl-BE") {
                    description = item.labelNl;
                }
                else if (selectedLanguage == "fr-BE") {
                    description = item.labelFr;
                }
                else {
                    description = item.labelEn;
                }

                return { ...item, label: description }
            })
            //setContactTitles();
            setTranslatedTitles(titlesWithLanguageChange)

            if (selectedTitle) {
                let _title = selectedTitle;
                let description = "";
                if (selectedLanguage == "nl-BE") {
                    description = selectedTitle.labelNl;
                }
                else if (selectedLanguage == "fr-BE") {
                    description = selectedTitle.labelFr;
                }
                else {
                    description = selectedTitle.labelEn;
                }

                if (_title.label != undefined) {
                    _title.label = description
                }
                //_title.label = description
                setSelectedTitle(_title);
            }
        }
        if (clientToken) {
            getContactTitleList();
        }
    }, [selectedLanguage, contactTitles, clientToken]);

    useEffect(() => {
        if (waitingListContactDetail != null && iframe == "waiting-list") {
            //console.log(waitingListContactDetail);
            let contactTitleId = null;

            if (waitingListContactDetail.contactTitle != null) {
                const contactTitle = JSON.parse(waitingListContactDetail.contactTitle);
                contactTitleId = (contactTitle != null && contactTitle.Id != null && contactTitle.Id != 0) ? contactTitle.Id : null; //|| contactTitle;
            }

            //const contactTitle = JSON.parse(waitingListContactDetail.contactTitle);
            setFirstName(waitingListContactDetail.contactName);
            setName(waitingListContactDetail.contactLastName);
            setEmail(waitingListContactDetail.contactEmail);
            setMobile(waitingListContactDetail.contactNumber);
            setSelectedTitle(contactTitleId);
            setEstateConfigurations(waitingListContactDetail.questionAnswerDetail);
        }
    }, [waitingListContactDetail]);

    const addNewContactOnWhiseForWaitingList = async () => {
        let uploadedFiles = await handleSubmit();
        setDocumentUrls(uploadedFiles.urls);
    }

    const addNewContactInLocalDBWaitingList = async () => {
        const checkFormValid = clickHandlerPreviewContactDetail();
        if (checkFormValid) {
            return;
        }
        try {
            setWaitingListBtnDisabled(true);
            let url = `${variables.API_URL}Calendar/waitlist-entries`;

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': "f422cf3c-a5f8-4115" // "12345" //
                },
            };

            let uploadedFiles = await handleSubmit();

            let updateObjectEstateconfigurations = null;

            if (estateconfigurations != null) {
                updateObjectEstateconfigurations = {
                    ...estateconfigurations,
                    requiredDocuments: estateconfigurations.requiredDocuments.map((docItem, index) => ({
                        ...docItem,
                        documentImageUrl: uploadedFiles.urls[index] || ""
                    }))
                }
            }

            let body = {
                clientID: clientId,
                firstname: firstName,
                lastname: name,
                email: email,
                estateId: estate.id,
                mobile: mobile,
                titleId: `${selectedTitle ? selectedTitle.value : 0}`,
                //contactId: contactId,
                languageId: selectedLanguage,
                countryId: 1,
                questionAnswerDetail: updateObjectEstateconfigurations,

            }

            const response = await axios.post(url, body, config)
            if (response.data) {
                setAddNewContactInWaitingTableStatus(response.data.status);
                setShowMessageIfAlreadyContactHavingEvents(response.data.statusCode);
                setFormStep(2);
                setWaitingListBtnDisabled(false);
            }
        }
        catch (err) {
            console.log(err);
            console.log(err.response.data.error);
            alert(err.response.data.error == "Missing or invalid API key" ? err.response.data.error : "An unexpected error occurred.");
            setWaitingListBtnDisabled(false);
            handleModalClsoe();
        }
    }
    function getDocImageName(url) {
        const path = url.split('?')[0];
        const base = path.substring(path.lastIndexOf('/') + 1);
        const match = base.match(/^[0-9a-fA-F-]{36}_(.+)$/); // match GUID_ filename
        const fileName = match ? match[1] : base;
        return fileName;
    }

    const sendEmailToClientForDuplicateWhiseEvent = (eventBody) => {

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        let html = "";
        html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border:1px solid gray;background:#fff;border-radius:16px;margin:0 auto;'>";

        html += "<tr><td style='text-align:center;padding:30px 0 40px'>";
        html += `<img src='${officeLogoUrl || clientSettings?.logoUrl || variables.AgentSiteURL + "assets/logo-placeholder.png"}' width='200' style='display:block;margin:auto'/>`;
        html += "</td></tr>";

        html += "<tr><td style='padding:0 20px 10px'>";
        html += `<h5 style='font-size:16px;font-weight:700;font-family:Roboto;margin:0'>${agentLanguageTranslation ? agentLanguageTranslation["hello"] : "Hello"},</h5>`;
        html += "</td></tr>";

        html += "<tr><td style='padding:0 20px 30px'>";
        html += `<p style='font-size:16px;font-family:Roboto;margin:0'>${agentLanguageTranslation ? agentLanguageTranslation["tbcSyncError"] : 'We have encountered an issue while trying to synchronise the "to be confirmed event".'} ${clientSettings?.name} (${clientId}) </p>`;
        html += "</td></tr>";

        html += "<tr><td style='padding:0 20px 40px'>";
        html += "<table width='100%' cellpadding='0' cellspacing='0' style='border:1px solid gray;border-radius:14px'>";

        html += "<tr><td style='padding:20px'>";
        html += `<h5 style='font-size:14px;font-family:Roboto;margin:0'>${agentLanguageTranslation ? agentLanguageTranslation["eventDetailsInternal"] : "Details of internal event"}</h5>`;
        html += "</td></tr>";

        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["eventIdInternal"] : 'Event ID internal:'} ${eventSlot.id}</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["eventIdWhise"] : 'WHISE Event ID:'} Null</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["eventStartDateTime"] : 'Start date time:'} ${eventBody.StartDateTime}</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["eventStartDateTime"] : 'End date time:'} ${eventBody.EndDateTime}</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["contactIdLabel"] : 'Contact ID:'} ${eventBody.ContactIds[0]}</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 14px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["propertyIdLabel"] : 'Property ID:'} ${eventBody.EstateIds[0]}</p></td></tr>`;
        html += `<tr><td style='padding:0 20px 20px'><p style='margin:0 font-size:14px;font-family:Roboto;'>${agentLanguageTranslation ? agentLanguageTranslation["slotBookingContactReviewAgent"] : 'Agent'} : ${eventBody.UserIds[0]}</p></td></tr>`;

        html += "</table>";
        html += "</td></tr>";
        html += "</table>";

        let subject = `${agentLanguageTranslation ? agentLanguageTranslation["mergeContactNotification"] : 'Notification of merge contacts in a TBC event'}`;

        //let sendTo = email;
        let sendTo = "smartcalendar-monitoring@mindfree.info"; //"abdulsaboor5059@gmail.com"
        let objEmail = {
            emailTo: sendTo,
            body: html,
            subject: subject,
            emailType: "agent"
        }

        const url = variables.API_URL + `Email/SendEmail?`;
        axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let resp = response.data;
                console.log(resp);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });

    }

    const addBookingSiteLandedLogsSaveInDB = async () => {

        try {
            const ipAddress = await getIpAddress();

            const url = `${variables.API_URL}Calendar/AddBookingSiteAcessLogs`;

            const contactTitle = typeof selectedTitle == "number" ? selectedTitle : selectedTitle?.value ?? null;

            const body = {
                estateId: +estate.id,
                clientId: clientId != "" ? clientId : null,
                contactId: contactId != "32065699" ? +contactId : null,
                ipAddress: ipAddress,
                contactFirstName: firstName,
                contactName: name,
                contactEmail: email,
                contactMobile: mobile,
                contactTitle: `${contactTitle}`

            }

            const response = await axios.post(url, body);
            if (response.data) {
                console.log(response.data);
            }


        } catch (error) {
            console.log(error);
        }
    }

    const sendEmailToAgentFreeSlotToConfirmedEvent = async (uploadedFiles) => {
        let agentEmail;
        try {
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const clientLanguage = clientSettings.defaultLanguageId;
            //console.log(estateconfigurations);
            let questionsHtml = "";
            if (estateconfigurations != null && estateconfigurations.questions != undefined && estateconfigurations.questions.length > 0) {
                let lastIndex = estateconfigurations.questions.length - 1
                estateconfigurations.questions.forEach((item, i) => {
                    if (item.answerText != undefined && item.answerText != "") {
                        let questionDetail = JSON.parse(item.questionDetail);
                        let title = questionDetail[`questionTitle-${agentLanguage}`]; // replace clientSettings.defaultLanguageId with agentLanguage
                        if (i == lastIndex) {
                            questionsHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; padding: 16px;margin-top: 0;'>";
                        }
                        else {
                            questionsHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; margin-bottom: 16px;margin-top: 0;padding: 16px;'>";
                        }
                        questionsHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                        questionsHtml += "            " + title + "";
                        questionsHtml += "        </p>";
                        questionsHtml += "        <p style='padding: 0px 12px;font-family:Roboto;font-size: 14px;color:#111827;text-align:left;margin-bottom:0;border: 1px solid #E9EAEC;border-radius: 10px; height: 52px;line-height: 53px;background-color: white;'>";
                        questionsHtml += "        " + item.answerText + "";
                        questionsHtml += "        </p>";
                        questionsHtml += "    </div>";
                    }
                });
            }

            let documentHtml = "";
            if (estateconfigurations != null && estateconfigurations.requiredDocuments != undefined && estateconfigurations.requiredDocuments.length > 0 && (estateconfigurations.inviteeConfig.Documents == true || estateconfigurations.inviteeConfig.documents == true)) {
                estateconfigurations.requiredDocuments.forEach((item, i) => {
                    let lastIndex = estateconfigurations.requiredDocuments.length - 1;

                    const findDocFileNo = Object.keys(selectedFiles).map(Number);
                    let docuUrl = "";
                    let fileName = "";
                    let finalDocURL = "";
                    let origin = "";
                    // console.log(item.documentImageUrl);
                    if (findDocFileNo.indexOf(item.id) >= 0) {
                        let _fileName = selectedFiles[`${item.id}`].name.replaceAll("_", "-"); //get selected file name from state
                        if (uploadedFiles && uploadedFiles.urls.length > 0) {
                            uploadedFiles.urls.forEach(url => {
                                let extractedFileName = url.split("UploadedFiles/")[1];
                                let splittedName = extractedFileName.split("_")[1];
                                if (splittedName == _fileName) {
                                    origin = variables.API_URL.split("api/")[0];
                                    fileName = extractedFileName;
                                    finalDocURL = origin + "UploadedFiles/" + extractedFileName;
                                }
                            })
                        }
                    }

                    if (waitingListContactDetail != null && iframe == "waiting-list") {
                        origin = variables.API_URL.split("api/")[0];
                        fileName = item.documentImageUrl ? item.documentImageUrl.substring(item.documentImageUrl.lastIndexOf('/') + 1) : ""; //.substring(item.imageUrl.lastIndexOf('/') + 1);
                        finalDocURL = `${origin}UploadedFiles/${fileName}` //item.documentImageUrl;
                    }

                    let documentTitle = item.isManualName == true ?
                        item.manualDocumentName
                        :
                        item.documentTypeId == 1 ?
                            agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalIdCardOptionForBooking"] : "ID card"
                            :
                            item.documentTypeId == 2 ?
                                agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalPaySlipOptionForBooking"] : "Pay slip"
                                :
                                item.documentTypeId == 3 ?
                                    agentLanguageTranslation ? agentLanguageTranslation["reqestDocModalBankStatementOptionForBooking"] : "Bank statement"
                                    :
                                    item.documentTypeName;

                    if (i == lastIndex) {
                        documentHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; padding: 16px;margin-top: 0;'>";
                    }
                    else {
                        documentHtml += "<div style='background-color: #f5f5f5; border-radius: 10px; margin-bottom: 16px;margin-top: 0;padding: 16px;'>";
                    }
                    documentHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                    documentHtml += "            " + documentTitle + "";
                    documentHtml += "        </p>";
                    documentHtml += "        <p style='font-family:Roboto;font-size:16px;color:#111827;text-align:left;margin-bottom:16px'>";
                    documentHtml += `           <a href="${finalDocURL}" target="_blank">${fileName}</a>`;
                    documentHtml += "        </p>";
                    documentHtml += "   </div>"
                })
            }

            let html = "";
            html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px auto; font-family: Roboto;'>";
            html += "   <tr>";
            html += "       <td style='text-align: center; padding: 30px 0px 50px 0px;'>";
            if (officeLogoUrl) {
                html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
            } else if (clientSettings != null && clientSettings.logoUrl != undefined) {
                html += "   <img src='" + clientSettings.logoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
            } else {
                html += "   <img src='" + variables.AgentSiteURL + "assets/logo-placeholder.png' width='200' style='margin: 0 auto; display: block;' />";
            }
            html += "       </td>";
            html += "   </tr>";
            html += "   <tr>";
            html += "       <td style='padding: 0 20px 15px 20px;'>";
            html += `           <h5 style='font-size: 20px; font-weight: 500;color: #111827; font-family: Roboto; margin: 0px; text-align: center; line-height: 1.3;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailHeading"] : "A Visit request has been booked trough the SmartCalendar online visit planner for (see below details)"}</h5>`;
            html += "       </td>";
            html += "   </tr>";

            html += "   <tr>";
            html += "       <td style='text-align: start; padding: 0 20px 10px 20px;'>";
            html += `           <p style='font-size: 14px; font-weight: 600; color: #111827;font-family: Roboto; text-align: left; margin: 0px; '>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailResumeHeading"] : "RESUME OF THE VISIT REQUEST"}</p>`;
            html += "       </td>";
            html += "   </tr>";
            html += "<tr>";
            html += "   <td style='text-align: center; padding: 0px 20px 30px 20px;'>";
            html += "       <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px;'>";
            html += "        <tbody>";
            html += "           <tr>";
            html += "               <td style='padding: 20px;'>";
            html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailDateTitle"] : "Date"}</h5>`;
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += "                   <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0px;'>" + formatDateTimeLanguageSpecific(agentLanguage != null ? agentLanguage : clientLanguage, eventSlot.startDateTime) + "</p>";
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += "                   <hr>";
            html += "               </td>";
            html += "           </tr>";
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px;'>";
            html += `                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailEstateHeading"] : "Property"}</h5>`;
            html += "               </td>";
            html += "           </tr>";

            html += "           <tr>";
            html += "               <td style='padding: 0 20px;'>";
            html += "                   <div style='float: left;'>";
            if (estate.pictures != undefined && estate.pictures.length > 0 && estate.pictures[0].urlLarge != undefined) {
                html += "                   <img src='" + estate.pictures[0].urlLarge + "' className='rounded-4' width='170' alt='house image' />";
            }
            html += "                   </div>";
            html += "                   <div style='float: left; padding-left: 20px'>";
            if (estate.name != undefined) {
                html += "                   <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;'> " + estate.name + " </h5>";
            } else {
                html += " ";
            }
            html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0; vertical-align: text-top;'>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/location-pin.png' width='15' style='vertical-align: text-top;' />";
            html += "                           &nbsp;" + (estate.address == undefined ? "" : estate.address) + " " + (estate.number == undefined ? "" : estate.number) + ", " + (estate.zip == undefined ? "" : estate.zip) + " " + (estate.city == undefined ? "" : estate.city);
            html += "                       </p>";

            html += "                       <p style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0 0 16px 0;vertical-align: middle;'>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/bed-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bedRooms == undefined ? "" : estate.bedRooms} </span>`;
            html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/shower-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.bathRooms == undefined ? "" : estate.bathRooms}</span>`;
            html += "                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'> | </span> <span style='vertical-align: middle;'> &nbsp; </span>";
            html += "                           <img src='" + variables.AgentSiteURL + "assets/lift-duo.png' width='20' style='vertical-align: middle;' />";
            html += `                           <span style='vertical-align: middle;'> &nbsp; </span> <span style='vertical-align: middle;'>${estate.area == undefined ? "" : estate.area}</span>`;
            html += "                       </p>";
            html += "                    </div>";
            html += "               </td>";
            html += "           </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 20px;'>";
            html += "                       <hr>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += `                       <h5 style='font-family: Roboto; font-size: 16px; color: #111827; text-align: left; margin: 0px;'>${agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailContactsHeading"] : "Contacts"}</h5>`;
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 5px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + firstName + " " + name + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 5px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + email + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       <p style='font-family: Roboto; font-size: 14px; color: #111827; text-align: left; margin: 0;'>" + mobile + "</p>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       <hr>";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       " + questionsHtml + "";
            html += "                   </td>";
            html += "               </tr>";
            html += "               <tr>";
            html += "                   <td style='padding: 0 20px 20px 20px;'>";
            html += "                       " + documentHtml + "";
            html += "                   </td>";
            html += "               </tr>";
            html += "               </tbody>";
            html += "           </table>";
            html += "       </td>";
            html += "   </tr>";
            html += "</table>";

            // replace with new condition "officeSetting.automaticSlotAcceptation"
            let subject = isAutomaticSlotAccept == "true" ? agentLanguageTranslation != null ? agentLanguageTranslation["agentDirectlyConfirmedEmailSubjectLbl"] : "Smartcalendar : A new visit has been added to your calendar" : agentLanguageTranslation != null ? agentLanguageTranslation["visitRequestAgentConfirmationEmailSubject"] : "Please Confirm the Booking";
            let sendTo = "";

            if (officeSetting.isVisitRequestManagementEnabled && officeSetting.reqManagementOfAgent && eventUser.id == officeSetting.reqManagementOfAgent) { // eventSlot.users[0].userId
                if (officeSetting.sendEmailTo == 2 && officeSetting.customEmail != "" && officeSetting.customEmail != null) {
                    sendTo = officeSetting.customEmail;
                } else if (officeSetting.sendEmailTo == 1 && whiseOffice.email != "") {
                    sendTo = whiseOffice.email;
                }
            }
            else if (officeSetting.isVisitRequestManagementEnabled && officeSetting.reqManagementOfAgent == null) {
                if (officeSetting.sendEmailTo == 2 && officeSetting.customEmail != "" && officeSetting.customEmail != null) {
                    sendTo = officeSetting.customEmail;
                } else if (officeSetting.sendEmailTo == 1 && whiseOffice.email != "") {
                    sendTo = whiseOffice.email;
                }
            }
            else {
                sendTo = eventUser.email; //eventSlot.users[0].email;
            }

            agentEmail = sendTo; // set agent email

            let objEmail = {
                emailTo: sendTo,
                body: html,
                subject: subject,
                emailType: "agent"
            }

            const url = variables.API_URL + `Email/SendEmail?`;
            const response = await axios.post(url, JSON.stringify(objEmail), jsonconfig) // ASP.NET Core API endpoint with headers
            let resp = response.data;
            if (resp == "Email Sent successfully") {
                console.log("Agent Email Sent successfully");
                return {
                    agentEmail: agentEmail,
                    resp: resp
                };
            } else {
                return {
                    agentEmail: agentEmail,
                    resp: resp
                };
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                agentEmail: agentEmail,
                resp: error
            };
        }
    }

    return (
        <>
            <Modal show={showModal} onHide={handleModalClsoe} className="modalStyle">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        {
                            formStep == 1
                                ?
                                <>
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between">
                                            {/*<p className="form-title">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalTitle"] : "Booking a free slot on:"} {time != null ? "(" + time + ")" : ""}</p>*/}
                                            <p className="form-title">{checkEstateStatusInDB == "Pending" ? selectedLanguageTranslations != null ? selectedLanguageTranslations["registrationHeading"] : "Registration on the waiting list" : selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalTitle"] : "Booking a free slot on:"}</p>
                                            <img src={closeIcon} onClick={handleModalClsoe} className="cursor-pointer" />
                                        </div>
                                    </div>
                                    <div className={`${checkEstateStatusInDB == "Pending" ? "d-none" : "d-flex"} bg-slot-time align-items-center justify-content-between rounded text-white px-2 px-sm-4 px-md-4 px-lg-4 px-xl-4 px-xxl-4 py-2 mb-3`}>
                                        <p className="d-flex justify-content-start align-items-center border-end col-7 mb-0 pe-2 py-1"><img src={dateIcon} className="me-1" /> <span>{formattedDate != null ? formattedDate : "Event Date"}</span>  </p>
                                        <p className="d-flex justify-content-end align-items-center col-5 mt-0 ps-2 py-1 mb-0"><img src={timeIcon} className="me-1" /> <span>{time}</span> </p>
                                    </div>
                                    <div className="mb-4">
                                        {
                                            translatedTitles.length > 0 ?
                                                <div className={`form-group mb-4`}>
                                                    <label className={`form-group-label mt-0`}>{selectedLanguageTranslations ? selectedLanguageTranslations["contactTitleDropdownLabel"] : "Title"}<span>*</span></label>
                                                    <select className={`form-select ${isTitleEmpty ? "border-red" : ""}`}
                                                        id="contactTitle" value={typeof selectedTitle == "number" ? selectedTitle : selectedTitle?.value ?? null} // selectedTitle?.value
                                                        onChange={handlerSelectContactTitle}>
                                                        <option value="">{selectedLanguageTranslations ? selectedLanguageTranslations["selectContactTitleDropdownPlaceholder"] : "Select Contact Title"}</option>
                                                        {
                                                            translatedTitles.map((item, index) => {
                                                                return (
                                                                    <option value={item.value} key={index}>{item.label}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                :
                                                <></>
                                        }
                                        <div className="form-group mb-4">
                                            <label className={`form-group-label mt-0`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactFirstName"] : "First Name"}<span>*</span></label>
                                            <input type="text" id="firstName" value={firstName} className={`form-control w-100 ${isFirstNameEmpty ? "border-red" : ""}`}
                                                placeholder={selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactFirstName"] : "First Name"}
                                                onChange={(e) => { setFirstName(e.target.value); removeValidationError("firstName"); }}
                                            />
                                        </div>
                                        <div className="form-group mb-4">
                                            <label className={`form-group-label mt-0`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactName"] : "Name"}<span>*</span></label>
                                            <input type="text" id="name" value={name} className={`form-control w-100 ${isNameEmpty ? "border-red" : ""}`}
                                                placeholder={selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactName"] : "Name"}
                                                onChange={(e) => { setName(e.target.value); removeValidationError("name"); }}
                                            />
                                        </div>
                                        <div className="form-group mb-4">
                                            <label className={`form-group-label mt-0`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactEmail"] : "Email"}<span>*</span></label>
                                            <input type="text" id="email" value={email} className={`form-control w-100 ${isEmailEmpty ? "border-red" : ""}`}
                                                placeholder={selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactEmail"] : "Email"}
                                                onChange={(e) => { setEmail(e.target.value); removeValidationError("email"); }}
                                            />
                                        </div>
                                        <div className="form-group mb-4">
                                            <label className="form-group-label mt-0">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactMobileNo"] : "Mobile"}<span>*</span></label>
                                            <PhoneInput
                                                country={'be'}
                                                onChange={onChangeMobileHandler}
                                                value={mobile}
                                                //onlyCountries={['be']}
                                                enableSearch={true}
                                                enableAreaCodes={false} // turn off area codes
                                                countryCodeEditable={false}
                                                inputClass={isMobileEmpty ? "border-red" : ""}
                                                buttonClass={isMobileEmpty ? "border-red" : ""}
                                            />
                                        </div>
                                    </div>

                                    <div className={`warning mb-4 ${freeTextForQuestions ? "" : "d-none"}`}>
                                        <p className="mb-0">
                                            {
                                                freeTextForQuestions != null ? freeTextForQuestions["freeText-" + selectedLanguage] : ""
                                            }
                                        </p>
                                    </div>

                                    <div>
                                        {
                                            estateconfigurations != null && estateconfigurations.questions != undefined &&
                                                (estateconfigurations.inviteeConfig.Question == true || estateconfigurations.inviteeConfig.question) &&
                                                estateconfigurations.questions.length > 0 ?
                                                estateconfigurations.questions.map((item, qIndex) => {
                                                    const questionDetail = JSON.parse(item.questionDetail);
                                                    const { answerType, answerOptions } = questionDetail;
                                                    const questionId = item.questionId;
                                                    const qCount = qIndex + 1;
                                                    const yesLabel = selectedLanguage === "en-GB" ? "Yes" : selectedLanguage === "fr-BE" ? "Oui" : "Ja";
                                                    const noLabel = selectedLanguage === "en-GB" ? "No" : selectedLanguage === "fr-BE" ? "Non" : "Nee";

                                                    return (
                                                        <div className="question-summary-container p-3 mb-4" key={item.order} id={`question${questionId}`}>
                                                            <div>
                                                                <p className="subtitle mb-3">{qCount}. {questionDetail[`questionTitle-${selectedLanguage}`]} {item.isMandatory ? <span className='text-red'>*</span> : ""} </p>
                                                            </div>
                                                            <div>
                                                                <p className="subtitle mb-3">{questionDetail[`questionDescription-${selectedLanguage}`]}</p>
                                                            </div>
                                                            <div>
                                                                {
                                                                    answerType == 2 || answerType == 3 && answerOptions.length > 0 ?
                                                                        answerOptions.map((option) => {
                                                                            let label = option[`option${option.id}-${selectedLanguage}`];

                                                                            let answerId = item.answerText == "Yes" ? 1 : item.answerText == "No" ? 2 : item.answerText == "other" || item.answerText == "I don't anwser" ? 3 : "";
                                                                            //console.log(item.answerId);
                                                                            return (
                                                                                <div className="mb-2" key={option.id}>
                                                                                    <label className="modal-p-text-black asnwer-options-preview d-flex align-items-center mb-2 w-100 me-2 line-height-0" htmlFor={`answerOption${qCount}${option.id}`}>
                                                                                        <input className="custom-radio me-2" value={option.id} type="radio" name={`answerOption${qCount}`} id={`answerOption${qCount}${option.id}`}
                                                                                            checked={item.answerId === option.id} // answerId === option.id
                                                                                            onChange={() => handleCheckBoxAnswerType(questionId, option.id, label)} />
                                                                                        {
                                                                                            label
                                                                                        }
                                                                                    </label>
                                                                                </div>
                                                                            )
                                                                        })
                                                                        :
                                                                        answerType == 1 ?
                                                                            <div className="d-flex col-6">
                                                                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0" htmlFor={`radio${item.order}`}>
                                                                                    <input className="custom-radio me-2" type="radio" name={`radio${item.order}`} id={`radio${item.order}`}
                                                                                        checked={item.answerText === 'Yes'}
                                                                                        onChange={() => handleFixCheckBoxAnswerType(questionId, 'Yes')} />
                                                                                    {yesLabel}
                                                                                </label>

                                                                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0" htmlFor={`radio${item.order}${answerType}`}>
                                                                                    <input className="custom-radio me-2" type="radio" name={`radio${item.order}`} id={`radio${item.order}${answerType}`}
                                                                                        checked={item.answerText === 'No'}
                                                                                        onChange={() => handleFixCheckBoxAnswerType(questionId, 'No')} />
                                                                                    {noLabel}
                                                                                </label>
                                                                            </div>
                                                                            :
                                                                            answerType == 4 || answerType == 5 ?
                                                                                <>
                                                                                    {
                                                                                        answerType == 4 ?
                                                                                            <input type="number" className={`form-control bg-white mb-2 no-spinner`}
                                                                                                onPaste={(e) => e.preventDefault()} onKeyDown={handleKeyDown}
                                                                                                onChange={(e) => handleTextBoxChangeAnswerType(e, questionId)}
                                                                                                value={item.answerText ?? ""}
                                                                                            />
                                                                                            :
                                                                                            <input type="text" className={`form-control bg-white mb-2`}
                                                                                                onChange={(e) => handleTextBoxChangeAnswerType(e, questionId)}
                                                                                                value={item.answerText ?? ""}
                                                                                            />
                                                                                    }

                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <input type="date" className="form-control bg-white mb-2"
                                                                                        onChange={(e) => handleTextBoxChangeAnswerType(e, questionId)}
                                                                                        value={item.answerText ?? ""}
                                                                                    />
                                                                                </>
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <></>
                                        }

                                    </div>

                                    <div className={`warning mb-4 ${freeTextForDocTypes ? "" : "d-none"}`}>
                                        <p className="mb-0">
                                            {
                                                freeTextForDocTypes != null ? freeTextForDocTypes["freeTextDocType-" + selectedLanguage] : ""
                                            }
                                        </p>
                                    </div>

                                    <div className={`question-summary-container p-3 mb-4 
                                    ${estateconfigurations != null && estateconfigurations.requiredDocuments != undefined && estateconfigurations.requiredDocuments.length > 0 ? "" : "d-none"}`}
                                    >
                                        <div>
                                            <p className="form-title mb-2">{selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalDocumentsHeadingForBooking"] + " " : "Documents"}</p>
                                        </div>
                                        <div>
                                            {
                                                estateconfigurations != null && estateconfigurations.requiredDocuments != undefined &&
                                                    (estateconfigurations.inviteeConfig.Documents == true || estateconfigurations.inviteeConfig.documents == true) &&
                                                    estateconfigurations.requiredDocuments.length > 0 ?
                                                    estateconfigurations.requiredDocuments.map((item, i) => {
                                                        let length = estateconfigurations.requiredDocuments.length;
                                                        let isErrorExist = errors[item.id];
                                                        let labelId = item.label.split(" ")[1];
                                                        return (
                                                            <>
                                                                <div className={`${isErrorExist ? 'rounded-red-border' : ''}`} id={`docType${item.id}`} key={i}>
                                                                    <p className="subtitle mb-1">
                                                                        {selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalDocumentsLabelForBooking"] + " " : "Document "} {labelId}
                                                                        {item.isMandatory ? <span className='text-red'>*</span> : ""}</p>
                                                                    <div>
                                                                        <button className={`btn btn-upload-file site-btn-padd d-flex justify-content-between align-items-center`}
                                                                            onClick={() => handleUploadClick(item.id)}>
                                                                            <span>
                                                                                <img src={fileIcon} className="me-2" />
                                                                                {
                                                                                    item.isManualName == true ?
                                                                                        item.manualDocumentName
                                                                                        :
                                                                                        item.documentTypeId == 1 ?
                                                                                            selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalIdCardOptionForBooking"] : "ID card"
                                                                                            :
                                                                                            item.documentTypeId == 2 ?
                                                                                                selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalPaySlipOptionForBooking"] : "Pay slip"
                                                                                                :
                                                                                                item.documentTypeId == 3 ?
                                                                                                    selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalBankStatementOptionForBooking"] : "Bank statement"
                                                                                                    :
                                                                                                    item.documentTypeName
                                                                                }
                                                                            </span>
                                                                            <span className="ms-2">
                                                                                <img src={uploadIcon} />
                                                                            </span>
                                                                        </button>
                                                                        <input
                                                                            type="file"
                                                                            id={`fileInput-${item.id}`}
                                                                            accept=".pdf, .doc, .txt, .jpg, .jpeg, .png"
                                                                            onChange={(e) => handleFileSelect(e, item.id)}
                                                                            style={{ display: "none" }}
                                                                        />
                                                                        {errors[item.id] && (
                                                                            <div className="text-red fs-small login-field-error">
                                                                                {errors[item.id]}
                                                                            </div>
                                                                        )}

                                                                        {/*{
                                                                            selectedFiles[item.id] && (
                                                                                <p className="upload-file-type mt-2">
                                                                                    Selected File: {item.documentImageUrl != "" && item.documentImageUrl != null ? item.documentImageUrl : selectedFiles[item.id].name}
                                                                                </p>
                                                                            )
                                                                        }*/}

                                                                        {
                                                                            selectedFiles[item.id] ? (
                                                                                <p className="upload-file-type mt-2">
                                                                                    Selected File: {selectedFiles[item.id].name}
                                                                                </p>
                                                                            ) : (
                                                                                item.documentImageUrl && item.documentImageUrl !== "" && (
                                                                                    <p className="upload-file-type mt-2">
                                                                                        Selected File: {getDocImageName(item.documentImageUrl)}
                                                                                    </p>
                                                                                )
                                                                            )
                                                                        }

                                                                        <p className="upload-file-type mb-0">{selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalDocFileUpdTypeStartTextForBooking"] : "Only"} <span className="text-success">Pdf, doc, txt, jpg, jpeg, png </span>{selectedLanguageTranslations ? selectedLanguageTranslations["reqestDocModalDocFileUpdTypeEndTextForBooking"] : "files are allowed. ( Max size : 5Mb )"}</p>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    i < length - 1 ? <hr /> : <></>
                                                                }
                                                            </>
                                                        )
                                                    })
                                                    :
                                                    <></>
                                            }
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        {
                                            requiredFieldMessage.length > 0 ? requiredFieldMessage.map(error => {
                                                return (
                                                    <p className="text-red fs-small login-field-error mb-2">{error.message}</p>
                                                )
                                            })
                                                :
                                                <></>
                                        }
                                    </div>
                                    <div className="d-flex">
                                        {
                                            checkEstateStatusInDB == "Pending" ?
                                                <>
                                                    <button className="filter-btn site-btn-padd color-dark w-100 me-3" >{selectedLanguageTranslations != null ? selectedLanguageTranslations["closeBtnTxt"] : "Close"}</button>
                                                    <button type="button" className="site-btn site-btn-padd w-100 pending-next-btn" onClick={addNewContactInLocalDBWaitingList} disabled={waitingListBtnDisabled}>
                                                        {
                                                            waitingListBtnDisabled ?
                                                                <div className="spinner-border text-light" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                                :
                                                                selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalNextBtn"] : "Next"
                                                        }
                                                    </button>
                                                </>
                                                :
                                                <button type="button" className="site-btn site-btn-padd w-100" onClick={clickHandlerPreviewContactDetail}>
                                                    {
                                                        disabledNextBtnInFormFistStep ?
                                                            <div className="spinner-border text-light" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                            :
                                                            selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalNextBtn"] : "Next"

                                                    }
                                                </button>
                                        }
                                    </div>
                                </>
                                : formStep == 2 ?
                                    <>
                                        {
                                            checkEstateStatusInDB == "Pending" ?
                                                <>
                                                    <div className="d-flex justify-content-between mb-4">
                                                        <p className="form-title">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalTitle"] : "Booking a free slot on:"}</p>
                                                        <img src={closeIcon} onClick={handleModalClsoe} className="cursor-pointer" />
                                                    </div>
                                                    <div className="text-center">
                                                        <img src={waitingScreenSuccess} className={`mb-3 ${showMessageIfAlreadyContactHavingEvents === "ExistInConfirmed" || showMessageIfAlreadyContactHavingEvents === "ExistsInToBeConfirm" ? "d-none" : ""}  `} />
                                                        <h6 className="success-message mb-2">
                                                            {
                                                                addNewContactInWaitingTableStatus === "already_exists"
                                                                    ? (selectedLanguageTranslations?.["alreadyOnList"] ?? "You are already on the waiting list")
                                                                    : addNewContactInWaitingTableStatus === "added_successfully"
                                                                        ? (selectedLanguageTranslations?.["waitingListSuccess"] ?? "It’s done! You are on the waiting list")
                                                                        : showMessageIfAlreadyContactHavingEvents === "ExistInConfirmed"
                                                                            ? (selectedLanguageTranslations?.["ExistInConfirmed"] ?? "We cannot submit your form as you've already a visit booked for that property. Please check your confirmation email.")
                                                                            : showMessageIfAlreadyContactHavingEvents === "ExistsInToBeConfirm"
                                                                                ? (selectedLanguageTranslations?.["ExistsInToBeConfirm"] ?? "We cannot submit your form as you've already sent a request to visit this property, please wait for the answer of the agent.")
                                                                                :
                                                                                ""
                                                            }
                                                        </h6>
                                                        <p className="hour-heading mb-4">
                                                            {
                                                                addNewContactInWaitingTableStatus === "already_exists"
                                                                    ? (selectedLanguageTranslations?.["notifySlotOpen"] ?? "We will send you a notification as soon as a visit slot opens.")
                                                                    : addNewContactInWaitingTableStatus === "added_successfully"
                                                                        ? (selectedLanguageTranslations?.["thankYouNotification"] ?? "Thank you! You will automatically receive a notification as soon as a new visit slot becomes available for this property.")
                                                                        : ""
                                                            }
                                                        </p>
                                                        <div className="d-flex">
                                                            {
                                                                showMessageIfAlreadyContactHavingEvents === "ExistInConfirmed" || showMessageIfAlreadyContactHavingEvents === "ExistsInToBeConfirm" ?
                                                                    <button className="filter-btn site-btn-padd color-dark w-100 me-3" onClick={handleModalClsoe}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["closeBtnTxt"] : "Close"}</button>
                                                                    :
                                                                    <>
                                                                        <button className="filter-btn site-btn-padd color-dark w-100 me-3" onClick={handleModalClsoe}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["closeBtnTxt"] : "Close"}</button>
                                                                        <a className="site-btn site-btn-padd w-100 see-property-btn" target="_self" href={whiseOffice?.website?.startsWith("http") ? whiseOffice.website : `https://${whiseOffice.website}`}>{addNewContactInWaitingTableStatus != null && addNewContactInWaitingTableStatus == "already_exists" ? selectedLanguageTranslations != null ? selectedLanguageTranslations["seeAvailableProperties"] : "See other available properties" : selectedLanguageTranslations != null ? selectedLanguageTranslations["seeOtherShort"] : "See other properties"}</a>
                                                                    </>
                                                            }
                                                            {/*<button type="button" className="site-btn site-btn-padd w-100">{addNewContactInWaitingTableStatus != null && addNewContactInWaitingTableStatus == "already_exists" ? selectedLanguageTranslations != null ? selectedLanguageTranslations["seeAvailableProperties"] : "See other available properties" : selectedLanguageTranslations != null ? selectedLanguageTranslations["seeOtherShort"] : "See other properties"}</button>*/}
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {
                                                        showMessageIfAlreadyContactHavingEvents != "" ?
                                                            <>
                                                                <div className="d-flex justify-content-between mb-4">
                                                                    <p className="form-title">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalTitle"] : "Booking a free slot on:"}</p>
                                                                    <img src={closeIcon} onClick={handleModalClsoe} className="cursor-pointer" />
                                                                </div>
                                                                <p className="mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations[showMessageIfAlreadyContactHavingEvents] : "This Contact Already having events"}</p>
                                                                <button className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={handleModalClsoe}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["cancelBtn"] : "Cancel"}</button>
                                                            </>
                                                            :
                                                            <>
                                                                <div className="d-flex justify-content-between mb-4">
                                                                    <p className="form-title">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactModalTitle"] : "Booking a free slot on:"}</p>
                                                                    <img src={closeIcon} onClick={handleModalClsoe} className="cursor-pointer" />
                                                                </div>
                                                                <div className={`${checkEstateStatusInDB == "Pending" ? "d-none" : "d-flex"} bg-slot-time align-items-center justify-content-between rounded text-white px-2 px-sm-4 px-md-4 px-lg-4 px-xl-4 px-xxl-4 py-2 mb-3`}>
                                                                    <p className="d-flex justify-content-start align-items-center border-end col-7 mb-0 pe-2 py-1"><img src={dateIcon} className="me-1" /> <span>{formattedDate != null ? formattedDate : "Event Date"}</span>  </p>
                                                                    <p className="d-flex justify-content-end align-items-center col-5 mt-0 ps-2 py-1 mb-0"><img src={timeIcon} className="me-1" /> <span>{time}</span> </p>
                                                                </div>
                                                                <div className="d-flex form-container form-container-expanded room-info mb-4">
                                                                    <div className="w-50">
                                                                        {
                                                                            estate != null && estate.pictures != undefined && estate.pictures.length > 0
                                                                                ?
                                                                                <img src={estate.pictures[0].urlLarge} className="property-img" />
                                                                                :
                                                                                <img src={placeholderLarge} className="property-img" />

                                                                        }
                                                                    </div>
                                                                    <div className="ms-2 py-3">
                                                                        <p className="mb-0 property-name ">
                                                                            {
                                                                                estate != null ?
                                                                                    estate.name
                                                                                    :
                                                                                    "Property Name"
                                                                            }
                                                                        </p>
                                                                        <div className="prop-address d-flex align-items-center mt-1">
                                                                            <img src={locationPin} className="me-1" />
                                                                            {
                                                                                estate != null ?
                                                                                    <>
                                                                                        <p className="mb-0">
                                                                                            {
                                                                                                (estate.address == undefined ? "" : estate.address) + " " +
                                                                                                (estate.number == undefined ? "" : estate.number) + ", " +
                                                                                                (estate.zip == undefined ? "" : estate.zip) + " " +
                                                                                                (estate.city == undefined ? "" : estate.city)
                                                                                            }
                                                                                        </p>
                                                                                    </>
                                                                                    //<p className="mb-0">{estate.address + " " + estate.number + ", " + estate.zip + " " + estate.city}</p>
                                                                                    :
                                                                                    <p className="mb-0">Address</p>
                                                                            }
                                                                        </div>
                                                                        <div className="row prop-detail-row mt-3">
                                                                            <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                                <img src={bedIcon} className={`${estate != null && estate.bedRooms != undefined ? "me-1" : ""} small-img-modal`} />
                                                                                <span className="smallImgIcon-Modal-info">
                                                                                    {
                                                                                        estate != null && estate.bedRooms != undefined ?
                                                                                            estate.bedRooms
                                                                                            :
                                                                                            <></>
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div className="col-4 d-flex align-items-center justify-content-center border-end">
                                                                                <img src={showerIcon} className={`${estate != null && estate.bathRooms != undefined ? "me-1" : ""} small-img-modal`} />
                                                                                <span className="smallImgIcon-Modal-info">
                                                                                    {
                                                                                        estate != null && estate.bathRooms != undefined ?
                                                                                            estate.bathRooms
                                                                                            :
                                                                                            <></>
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div className="col-4 d-flex align-items-center">
                                                                                <img src={liftIcon} className={`${estate != null && estate.area != undefined ? "me-1" : ""} small-img-modal`} />
                                                                                {
                                                                                    estate != null && estate.area != undefined ?
                                                                                        <span className="smallImgIcon-Modal-info">{estate.area}<span className="ms-05">m</span><sup>2</sup></span>
                                                                                        :
                                                                                        <></>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center border-bottom-end mb-4">
                                                                    <p className="subtitle mb-0"><img src={userIcon} className="me-2" />{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewFullName"] : "Full Name"} </p>
                                                                    <div className="text-end">
                                                                        {
                                                                            name != "" ?
                                                                                <p className="subtitle mb-0">{firstName} {name}</p>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center border-bottom-end mb-4">
                                                                    <p className="subtitle mb-0"><img src={envelopeIcon} className="me-2" />{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewEmail"] : "Email"} </p>
                                                                    <div className="text-end">
                                                                        {
                                                                            email != "" ?
                                                                                <p className="subtitle mb-0">{email}</p>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center border-bottom-end pb-4 border-bottom">
                                                                    <p className="subtitle mb-0"> <img src={phoneBlack} className="me-2" />{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewMobile"] : "Mobile"}</p>
                                                                    <div className="text-end">
                                                                        {
                                                                            mobile != "" ?
                                                                                <p className="subtitle mb-0">{mobile}</p>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={`${checkEstateStatusInDB == "Pending" ? "d-none" : "d-flex"} justify-content-between align-items-center border-bottom-end mb-4 pt-4`}>
                                                                    <p className="subtitle mb-0"><img src={userIcon} className="me-2" />{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewAgent"] : "Agent"}</p>
                                                                    <div className="text-end">
                                                                        {/*{
                                                                eventSlot != null && eventSlot.users.length > 0 ?
                                                                    eventSlot.users.map(item => {
                                                                        return (
                                                                            <p className="subtitle mb-0">{item.firstName} {item.name}</p>
                                                                        )
                                                                    })
                                                                    :
                                                                    <></>
                                                            }*/}
                                                                        {
                                                                            eventUser != null ?
                                                                                <p className="subtitle mb-0">{eventUser.firstName} {eventUser.name}</p>
                                                                                :
                                                                                <></>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex">
                                                                    <button className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={handleMoveToPreviousScreen}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewCancelBtn"] : "Cancel"}</button>
                                                                    {/*<button className="site-btn site-btn-padd w-100" onClick={handlerMoveToEmailVerification}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewConfirmBtn"] : "Next"}</button>*/}
                                                                    <button className="site-btn site-btn-padd w-100 pending-next-btn" onClick={checkEstateStatusInDB == "Pending" ? addNewContactOnWhiseForWaitingList : clickHandlerConfirmSlot} disabled={waitingListBtnDisabled}>
                                                                        {
                                                                            waitingListBtnDisabled ?
                                                                                <div className="spinner-border text-light" role="status">
                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                </div>
                                                                                :
                                                                                selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingContactReviewConfirmBtn"] : "Next"
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </>
                                                    }
                                                </>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className="d-flex justify-content-between align-items-start mb-4">
                                            {
                                                officeLogoUrl ?
                                                    <img src={officeLogoUrl} width="200" />
                                                    :
                                                    clientSettings != null && clientSettings.logoUrl != undefined ?
                                                        <img src={clientSettings.logoUrl} width="200" />
                                                        :
                                                        <img src={mindfreeLogo} />
                                            }
                                            <img src={closeIcon} onClick={handleModalClsoe} className="cursor-pointer" />
                                        </div>
                                        <div className="message-container">
                                            {
                                                tbcEventNotUpdate ?
                                                    <>
                                                        <img src={errorMessage} className="mb-4" />
                                                        <p className="fw-bold">{selectedLanguageTranslations ? selectedLanguageTranslations["tbcEventSyncFailureExceptionMessage"] : "To Be Confirmed’ Event Details Not Updated in Database"}</p>
                                                    </>
                                                    :
                                                    <>
                                                        <img src={successTick} className="mb-4" />
                                                        <p className="success-message mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingSuccessModalHeading"] : "Congratulations your visit request has been booked successfully"}</p>
                                                        <p className="thanks-message">{selectedLanguageTranslations != null ? selectedLanguageTranslations["slotBookingSuccessModalSubHeading"] : "Thank you for using our booking."}</p>
                                                    </>
                                            }
                                        </div>
                                    </>
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}





